/* eslint-disable */
/*
Notes: we should combine code from CreatePostSaga and EditPostScreen into PostSagas.js.
Right now we have three sets of code, each screen choosing which to use.
*/

import React, { Component } from 'react'
//import { AsyncStorage } from '@react-native-async-storage/async-storage'
// imported differently for web build
import AsyncStorage from '@react-native-async-storage/async-storage'

import {
  TouchableWithoutFeedback,
  ScrollView, Text, KeyboardAvoidingView,
  Image, ImageBackground, View, TouchableOpacity,
  Animated, Easing, Dimensions, Keyboard, StatusBar, ImageEditor, ImageStore, Alert, TouchableHighlight, WebView,
  CameraRoll, Modal, Platform
} from 'react-native'
import { Switch } from 'native-base'
import { connect } from 'react-redux'
import { RecyclerListView, DataProvider, LayoutProvider } from "recyclerlistview"
import BaseScreen from './BaseScreen'
import MainNavBarScreen from './MainNavBarScreen'
import IconWithTextComponent from '../Components/IconWithTextComponent'
import SearchBarComponent from '../Components/SearchBarComponent'
import TextComponent from '../Components/TextComponent'
import CaptionComponent from '../Components/CaptionComponent'
//import SharingComponent from '../Components/SharingComponent'
//import DragComponent from '../Components/DragComponent'
// import EditPostEndorse from '../Components/EditPostEndorse'
//import EditPostEndorseV2 from '../Components/EditPostEndorseV2'
//import EditPostPeople from '../Components/EditPostPeople'
//import EditPostMusic from '../Components/EditPostMusic'
//import EditPostDonation from '../Components/EditPostDonation'
//import RNFetchBlob from 'react-native-fetch-blob'
//import RNFS from 'react-native-fs'
// import EditPostMyShop from '../Components/EditPostMyShop'
//import EditPostMyShopV2 from '../Components/EditPostMyShopV2'
import AlertMessage from '../Components/AlertMessage'
import { ModalMessage, MoneyFaceMessage, ThumbsDownMessage } from '../Components/ModalMessage'
import { getUri, checkPrice, i18nCurrency, i18nCurrencyDuo, getTimeStamp, markImageWithWatermark, parseQRCode, deepClone, getAvatar } from '../Lib/utils'
import styles from './Styles/EditPostScreenStyle'
import { SvgDivider } from '../Components/SvgComponent'
import Immutable from 'seamless-immutable'
import UserActions from '../Redux/UserRedux'
import PostsActions from '../Redux/PostsRedux'
import SwiperActions from '../Redux/SwiperRedux'
import KargoeTagActions from '../Redux/KargoeTagRedux'
import GetFollowActions from '../Redux/GetFollowRedux'
import KargoeCareActions from "../Redux/KargoeCareRedux"
import UserPopularActions from "../Redux/UserPopularRedux"
import PaypalActions from '../Redux/PaypalRedux'
import ShoppableActions from "../Redux/ShoppableRedux"
import CouponActions from '../Redux/CouponRedux'
import AppleMusicActions from '../Redux/AppleMusicRedux'
import { MEDIA_TYPE, USER_KIND } from '../Constant';
//import LocationComponent from '../Components/LocationComponent'
import { SvgLocationPin, SvgLocationX } from '../Components/SvgComponent'
import { Fonts, Images } from '../Themes'
//import Video from 'react-native-video'
import { KeyboardAwareScrollView, convertToPercent, isBlank, convertPercentToPoint, alertView } from '../Lib/utils'
import { isIPhoneX, DONATATION, PEOPLE, MUSIC, MYSHOP, ENDORSE, LOCATION } from '../Lib/utils'
import { KargoeConfig } from '../Config/AppConfig'
import API from '../Services/Api'
import FixtureAPI from '../Services/FixtureApi'
import DebugConfig from '../Config/DebugConfig'
//import { KeyboardAccessoryNavigation } from 'react-native-keyboard-accessory'
//import RNInstagramShare from 'react-native-instagram-share';
//import TwitterShare from '../Lib/TwitterShare'
//import TumblrShare from '../Lib/TumblrShare'
//import { ShareDialog } from 'react-native-fbsdk'
//import { AppInstalledChecker, CheckPackageInstallation } from 'react-native-check-app-install';
import { NavigationActions } from 'react-navigation'
//import { captureRef } from 'react-native-view-shot'
import I18n from "i18n-js"
//import userDefaults from 'react-native-user-defaults'
import { setBadgeCount } from 'react-native-notification-badge'
import {TinyEmitter} from 'tiny-emitter'
//import LiveBroadcastScreen from '../Containers/LiveBroadcastScreen'
import PhotoManipulator from 'react-native-photo-manipulator'

import SoundPlayer from 'react-native-sound-player'

const { width, height } = Dimensions.get('window')
const heightImage = height - 64 - 130

const startY = height - 64 - 130
const endY = 80 // 30

const CREATE = "create"
// move these later not at app start or it doesnt get dynamic language setting
//const EDIT = I18n.t('editpost.title') // "edit"
//const REPOST = I18n.t('editpost.repost') // "repost"
//const EDITPOST = "Edit Post"
//const SHARING = "Sharing"

const tabDefault = [false, false, false, false, false, false]
const baseURL = KargoeConfig.baseUrlAPI
const coordinateDefault = {
  x: width / 2 - 50,
  y: height / 2 - 64
}
class EditPostScreen extends Component {

  static songdex = 0
  
  constructor(props) {
    super(props);
    AsyncStorage.getItem("EditPostScreenSavedCaption")
    .then(res => {
    if (res !== null) {
      console.log("edit post screen got from async storage " + res)
      if (this.captionRef) {
        this.captionRef.value = res
        this.captionRef.setState({ render : true })
      }
      this.setState({caption : res})
    } else console.log("nothing from async storage")
    })
    .catch(err => console.log("catch error from async storage read " + JSON.stringify(err)))

    var type = CREATE
    if (props.navigation.state && props.navigation.state.params && props.navigation.state.params.postType) {
      type = props.navigation.state.params.postType
    }

    if (props.navigation.state && props.navigation.state.params && props.navigation.state.params.fromMessages)
      this.fromMessages = true
    
    if (props.navigation.state && props.navigation.state.params && props.navigation.state.params.fromWebWall)
      this.fromWebWall = true

    console.log("this.fromMessages = " + this.fromMessages)
    
    // call these two in constructor so that they take current language setting into account
    this.EDIT = I18n.t('editpost.title') // "edit"
    this.REPOST = I18n.t('editpost.repost') // "repost"
    this.EDITPOST = I18n.t('editpost.supertitle') // "Edit Post" (no, just Edit in the translate table oops, use new supertitle instead)
    this.TAGGING = I18n.t('editpost.tagging')
    this.SHARING = I18n.t('editpost.sharing')
    this.api = DebugConfig.useFixtures ? FixtureAPI : API.create()
    this.api.setAuthorization(this.props.auth.token)
    this.arrayText = [I18n.t('editpost.people'), I18n.t('editpost.music'), I18n.t('editpost.myshop'), I18n.t('editpost.endorse'), I18n.t('editpost.donation'), I18n.t('editpost.location')]
    // these should be english
    this.arrayIcon = ['People', 'Music', 'My Shop', 'Endorse', 'Donation', 'Location']
    this.offsetY = new Animated.Value(0)
    this.commentBox = new Animated.Value(0)
    this.sharingComponent = false // ref to sharing component
    this.searchOptions = {}
    this.firstCallComponentDidUpdate = true

    // one method to get the barcode is from camera internal, not javascript.  Objective C qrcode is cleared out when you cancel creating the post, shake-refresh won't do it.
    let qrcode = (this.props.navigation.state.params &&
      this.props.navigation.state.params.image) ?
      this.props.navigation.state.params.image.barcodeOrQRScanResult : ''
    if (!qrcode)
      qrcode = this.props.recentBarcoderOutput

    this.initialState = { locationId : '', locationCoord : '', locationName : '', song: null
                        , userTags : [ ], theySell : [ ], iSells : [ ], donate : [ ]
                        , caption : '', endorseText : '', peopleText : '', musicText: this.props.music.search, donationText : ''
                        , charities : [ ]
                        , peoples : [ ]
                        , offsetY : 0, arrayActive : tabDefault
                        , screenTitle : type == this.EDIT ? this.EDITPOST : I18n.t('editpost.tagging') // note:  english only (can't just fix this, have to look at all references of it
                        , uriToUse : '' // FOR RENDERING A FRAME FROM THE CAMERA
                        , Expired : true, type : type
                        , switchIsOn : false // to share to 3rd party services (tags)
                        , switchIsOnLogo : false // to share to 3rd party services (logo)
                        , isVideoRendering : false, waitingForPost : false
                        , naturalAR : 4/3 // of image or video, from media, computed on the fly
                        , showDoneBar : true
                        , productDetail : null // for overlay

                        // ISell registers (inappropriate imo but whatever)
                        , priceState : 0, currencyState: '', countText : '', priceTop : 0
                        , myshopDes : '', myshopTitle : '', errorPayPal : false,

                        // Paypal account checking
                        userLoaded: false,
                        isStandardUser: null,
                        havePaypal: null,
                        basicPaypalReqMet: null,
                        user: null,
                        qrcode,
                        ktagCallerInfo: this.props.navigation.state.params.ktagCallerInfo,
                        scanKind: null,
                        offer : null,
                        vendor: null,
                        vendorOffersUserId: null,
                        vendorOffers: null,
                        showQRAlert: false,
                        alertMessage: '',
                        errorMessage: '',
                        modified: null,
                        showTagCloseButtons: true, // normally true, set to false for sharing w/ tags
                        videoRenderProgress: 0, // for fast render situation
                        isLivePost: false,
                        inMyShop: false,
                        }
    console.tron.display({name: `EditPostScreen`,preview: `constructor`,value: {nav: props.nav, props: this.props, initialState: this.initialState}})
    this.state = Object.assign({ }, this.initialState) // deep copy

    this.defaultImageUrl = null
    if (this.state.type == this.EDIT || this.state.type == this.REPOST) {
      console.log("ready to pull from nav")
      const { navigation: { state: { params: { data } } } } = this.props
      this.defaultImageUrl = getUri(data.PostId, data.Version)
    }

    // if a caption was still there (e.g. partial post, user cancelled), use it
    /* move to did mount
    userDefaults.get('editPostScreenCaption')
     .then(data =>
           { console.log("user defaults get caption = " + data)
             if (typeof data === 'string' && data.length > 0)
               this.setState({caption : data})
           }
          )   // value for the key
    */
    // wipe barcode from post wall
    this.props.changeIndex({ktagCallerInfo: null, barcoderOutput: null})

    this.tagRefs = { 'donate': [], 'user': [], 'isell': [], 'theysell': [] }
    this.endorseDataProvider = new DataProvider((r1, r2) => {
      return r1.ItemId != r2.ItemId
    })
    this.endorseSearch = {
      search: '',
      items: [],
      modified: null,
    }
    this.loadMoreEndorseData = this.loadMoreEndorseData.bind(this)
    this.addSong = this.addSong.bind(this)
    this.addProductEndorseCaption = this.addProductEndorseCaption.bind(this)
    this.showProductDetail = this.showProductDetail.bind(this)
    this.findOpenSpace = this.findOpenSpace.bind(this)
    this.isOverlappingTag = this.isOverlappingTag.bind(this)
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this)
    this.clearAlertMessage = this.clearAlertMessage.bind(this)
    this.clearErrorMessage = this.clearErrorMessage.bind(this)
    this.componentDidMount = this.componentDidMount.bind(this)
    this.searchMusic = this.searchMusic.bind(this)
    this.onMusicSearch = this.onMusicSearch.bind(this)
    this.mainContainerView = null // for capturing image w/ tags
    this.deactivateTabs = this.deactivateTabs.bind(this)
    // this.hideProductDetail = this.hideProductDetail.bind(this)

    // when do we clear the QR code?  it may be "never" at this point.  word to the wise.

    //const camInternal = qrcode ? true : false // barcode is from cam internal and we have not gotten the offer yet

    //const qrcode = this.props.navigation.state.params.image.barcodeOrQRScanResult

    console.log("QR code from redux " + this.props.recentBarcoderOutput)

    console.log("in render qrcode = " + qrcode)

    // don't want to look for qrcode, want to look for actual offer

    if (false) {
    // use this to see if we should mask the live post button or not,
    // e.g. is the auth user name in the keys of this object
    this.liveStreamTokens = LiveBroadcastScreen.getLiveStreamTokens()

    console.log("edit post screen live screen tokens = " + JSON.stringify(this.liveStreamTokens))

    }
  }

  onToggleSwitch = () => this.setState({ switchIsOn: !this.state.switchIsOn }) // share tags
  onToggleSwitchLogo = () => this.setState({ switchIsOnLogo: !this.state.switchIsOnLogo }) // share logo

  animate(arrayActive) {
    if (this.commentBox.__getValue() == 1) this.inputCapnofocus()
    Animated.timing( this.offsetY, { toValue: this.offsetY.__getValue() == 0 ? 1 : 0, duration: 500, easing: Easing.cubic })
      .start(() => console.tron.display({name: `Animated`,preview: ``,value: {state: this.offsetY}}))
  }
  componentWillMount ( ) {
    this.subs = [
      this.props.navigation.addListener('didFocus', ( ) => {
        this.setState({ focused : true })
        console.log('edit post screen did come into focus')
        this.props.status({ status: {}, then: this.onPaypalStatus, err: this.onPaypalError })
      })
    , this.props.navigation.addListener('willBlur', ( ) => {
        this.setState({ focused : false })
        console.log('edit post screen will blur')
      })
    ]
  }

  componentWillUnmount() {
    var arrayActive = this.state.arrayActive
    for (var i = 0; i < arrayActive.length; i++) arrayActive[i] = false

    this.setState({ arrayActive })
    this.enableKeyboardListeners(false)
    this.subs.forEach(sub => sub.remove( ))
  }

  enableKeyboardListeners = (enable) => {
    console.log(`enableKeyboardListeners ${enable}`)
    if (enable) {
      this.keyboardWillShowListener = Keyboard.addListener('keyboardWillShow', this.keyboardWillShow.bind(this))
      this.keyboardWillHideListener = Keyboard.addListener('keyboardWillHide', this.keyboardWillHide.bind(this))
    }
    else {
      if (this.keyboardWillShowListener)
        this.keyboardWillShowListener.remove()
      if (this.keyboardWillHideListener)
        this.keyboardWillHideListener.remove()
      this.keyboardWillShowListener = null
      this.keyboardWillHideListener = null
    }
  }

  componentDidMount ( ) {
    // console.tron calls do not work in here for some reason, console.log does

    const offer = this.props.coupon.getOffer.record
    const vendor = this.props.coupon.getVendor.record
    const qrCodeDetails = parseQRCode(this.state.qrcode)
    if (qrCodeDetails.OfferId)
      this.setState({scanKind: 'offer'})
    if (qrCodeDetails.VendorId)
      this.setState({scanKind: 'vendor'})
    console.log(`EditPostScreen componentDidMount qrCodeDetails`, qrCodeDetails, offer)
    if (offer && (offer.OfferId === qrCodeDetails.OfferId)) {
      console.log("EditPostScreen componentDidMount have offer already")
      if (typeof offer.UserKind == 'undefined')
        this.setErrorMessage(`QR Code is for an invalid Offer, missing UserKind.`)
      else if (offer.UserKind == USER_KIND.MERCHANT)
        this.setErrorMessage(`QR Code is for an Offer from a Merchant, which is invalid.`)
      else if (offer.UserKind == USER_KIND.CHARITY) {
        this.setState({offer : offer}, this.autoAddDonateTagForBarCode)
      }
    }
    else if (vendor && (vendor.UserId === qrCodeDetails.VendorId)) {
      console.log("EditPostScreen componentDidMount have vendor already", vendor)
      this.searchOptions = {
        UserId: vendor.UserId
      }
      this.setState({vendor : vendor})
      this.setAlertMessage(`Endorse an item from ${vendor.StoreName} and share the Post to get a coupon.`)
    }
    else {
      if (qrCodeDetails.OfferId)
        this.props.getOffer(qrCodeDetails.OfferId, null)
      else if (qrCodeDetails.VendorId)
        this.props.getVendor(qrCodeDetails.VendorId)
      else {
        console.tron.log(`Try and find in Kargoe's items...`)
        this.props.searchItems({ search: qrCodeDetails.ItemId, filter: "CODE_LOOKUP", limit: 1 })
      }
    }

    this.props.readUser(this.props.auth.user.UserId)
    this.props.getFollowing(this.props.auth.user.UserId) // already happens when bringing up editpost
    if( this.state.type === 'LINK' ) {
      this.setState({ uriToUse : 'data:image/jpeg;base64,'+this.props.navigation.state.params.data.b64 }
    , ( ) => console.log(`set uriToUse to ${this.state.uriToUse}`))

    } else if(this.state.type != CREATE) {
      console.log("ready to read post with post id " + this.props.navigation.state.params.data.PostId)
      this.props.readPost({ PostId: this.props.navigation.state.params.data.PostId })
      console.log('did read post')
      if (this.state.type != this.REPOST)
        this.props.getPostTagDetail({ PostId: this.props.navigation.state.params.data.PostId })
    } else {
      console.log("caution, setting caption to blank")
      //alertView("caution, setting caption to blank", "")
      this.setState({ caption: ''
                    , userTags: [], theySell: [], iSells: [], donate: []
                    , locationId: '', locationCoord: '', locationName: '', song: null
										})
/*
      userDefaults.get('editPostScreenCaption')
      .then(data =>
            { console.log("user defaults get caption = " + data)
                            if (typeof data === 'string' && data.length > 0) {
                               if (this.captionRef) {
                                  this.captionRef.value = data
                                  this.captionRef.setState({ render : true })
                                  this.setState({caption : data})
                               }
                            }
            }
           )   // value for the key
*/
    }

    const ktag = this.state.ktagCallerInfo
    if( ktag ) this.addProductEndorseCaption(JSON.parse(ktag))

    this.props.getCharities ( )
    // this.props.listFollowing (this.props.UserId, 0)
    this.checkTypeImageOrVideo ( ) // this happens before video is fully rendered and initial image (poster) may be wrong aspect ratio
    this.enableKeyboardListeners(true)

    this.navigationBar.setRightNavBarButtons([{onPress: this.handleSave,title: this.state.type == this.EDIT ? I18n.t('signUp.save') : I18n.t('editpost.next'), type: 'title'}])
    this.navigationBar.setLeftNavBarButtons([{ onPress: this.handleBack, title: I18n.t('editpost.back'), type: 'title' }])

    if (this.props.options.useShoppableTagging)
      this.props.shoppableGetConfig()
    this.props.shoppableCatalogSearch('', 0, 100, this.searchOptions) // getKargoeTag({ limit: 10, filter: "THEYSELL_ONLY" }) // searchItems getKargoeTag (do not need posts for the items here)
    this.setState({ shoppableSearch : true })

    if (this.captionRef)
      this.captionRef.textInput.focus( )

  }

  keyboardWillShow = (e) => {
    this.setState({ priceTop: - e.endCoordinates.height });
  }

  keyboardWillHide = (e) => {
    this.setState({ priceTop: 0 });
  }
  inputPriceNofocus = () => {
    this.setState({
      priceTop: 0,
      showDoneBar: true
    })
  }
  inputPricefocus = () => {
    this.setState({
      showDoneBar: false
    })
  }
  inputCapnofocus = () => {
    Animated.timing(
      this.commentBox,
      {
        toValue: this.commentBox.__getValue() == 0 ? 1 : 0,
        duration: 500,
        easing: Easing.cubic
      }
    ).start(() => { })
    this.setState({ render : true })
  }
  inputCapforcus = () => {
    Animated.timing(
      this.commentBox,
      {
        toValue: this.commentBox.__getValue() == 0 ? 1 : 0,
        duration: 500,
        easing: Easing.cubic
      }
    ).start(() => { })
    this.setState({ render : true })
  }

  hasGoFundMeEntry = (authUser) => {
    let hasEntry = false
    this.state.donate.forEach(entry => {
      if (entry.CharityId == authUser.UserId)
        hasEntry = true
    })
    return hasEntry
  }

  makeGoFundMeEntry = (authUser) => {
    return {
      CharityId: authUser.UserId,
      PaypalEmail: authUser.PaypalEmail,
      Currency: authUser.Currency,
      CharityName: `Donation to ` + authUser.Username,
      ImageUrl: getAvatar(authUser.UserId),
      FundMe: true,
      Amount: 0,
    }
  }
  
  onValueChangeLivePost = (enabled) => {
    // streaming
    this.setState({isLivePost : enabled})
    const missingPaypal = this.state.userLoaded && this.state.isStandardUser ? !this.state.havePaypal : this.state.Expired
    if (!missingPaypal && enabled)
      if (!this.hasGoFundMeEntry(this.props.auth.user))
        this.addTagDonation(this.makeGoFundMeEntry(this.props.auth.user))
  }

  checkTypeImageOrVideo = () => {

    if (this.props.navigation.state.params.image)
      console.log("this.props.navigation.state.params.image keys = " + 
        JSON.stringify(Object.keys(this.props.navigation.state.params.image))
      )

    // ios app comes in with these keys in params.image when it's a video (video not rendered yet)

    // ["stillImageAsBase64","is3DMovie","movieUrlAsNSString","height","width","uri"]

    var uri = ''
    var isVideoRendering = false
    console.log("check type image or vid, type = " + this.state.type)
    if (this.state.type == CREATE) {
      uri = this.props.navigation.state.params.image.uri
      console.log("QR code in edit post screen = " + this.props.navigation.state.params.image.barcodeOrQRScanResult)
      console.log("QR code from redux " + this.props.recentBarcoderOutput)
      if (this.props.navigation.state.params.image.movieUrlAsNSString && !this.props.tileurl) {
        isVideoRendering = true
      }
    } else if (this.state.type == this.EDIT || this.state.type == this.REPOST) {
      console.log("ready to pull from nav")
      const { navigation: { state: { params: { data } } } } = this.props
      isVideoRendering = false
      console.log("edit data = " + JSON.stringify(data))
      uri = getUri(data.PostId, data.Version)
    }

    // only use the rendered frames when we are CREATE-ing a video post, or lingering data in oneRenderedFrame disrupts the edit post process
    // after a recent video post
    var uriToUse = this.state.type == 'LINK'
      ? 'data:image/jpeg;base64,'+this.props.navigation.state.params.data.b64
      : ((this.props.oneRenderedFrame && this.state.type == CREATE) ? this.props.oneRenderedFrame : uri)


    if (this.props.navigation.state.params.image &&
      this.props.navigation.state.params.image.movieUrlAsNSString &&
      this.props.finalRenderedVideo &&
      this.props.tileurl &&
      this.props.thumburl) {
      isVideoRendering = false
    }

    console.log("set isVideoRendering " + isVideoRendering + " loc X")
    this.setState({isVideoRendering})
    //console.log("uriToUse = " + uriToUse)
    if (uriToUse) {
      Image.getSize(uriToUse, (widthImage, heightImage) => {  /*this.setState({width, height})*/
        // 9/16 ratio (HD portrait) comes in ok here
        console.log("loc 1 naturalAR = " + (widthImage / heightImage))
        this.setState({naturalAR: widthImage / heightImage,uriToUse: uriToUse})
      });
    } else {
      this.setState({uriToUse: uri})
    }

  }

  asynSetTaggingTheySell = async (tags) => {
    let theySell = this.state.theySell
    console.tron.display({
      name: `asynSetTaggingTheySell`,
      preview :``,
      value: {
        theySell: theySell,
        tags: tags
      }
    })
    for (let i = 0; i < theySell.length; i++)
      for (let j = 0; j < tags.length; j++)
        if (theySell[i].ItemId == tags[j].ItemId) {
          const tagDetails = tags[j]
          let newTag = Object.assign({}, theySell[i])
          newTag.Image = tagDetails.Image
          newTag.PriceMin = tagDetails.PriceMin == undefined ? "" : tagDetails.PriceMin
          newTag.PriceMax = tagDetails.PriceMax == undefined ? "" : tagDetails.PriceMax
          theySell[i] = newTag
        }
    this.setState({
      theySell: theySell
    })

  }
  asynSetTaggingDonate = async (tags) => {
    var donate = this.state.donate
    for (var i = 0; i < donate.length; i++)
      for (var j = 0; j < tags.length; ++j)
        if (donate[i].CharityId == tags[j].CharityId) {
          var newTag = Object.assign({}, donate[i], {Currency: 'USD'})
          newTag.ImageUrl = tags[j].ImageUrl // bug noted in crashlytics, use j index for tags array
          donate[i] = newTag
        }

    this.setState({
      donate: donate
    })

  }
  convertISell = (post) => {
    var newIsell = post.ISell.asMutable()
    console.log("convertIsell before = " + JSON.stringify(post))
    console.log("convertIsell after = " + JSON.stringify(newIsell))
    if (newIsell.length > 0) {
      const isellModify = newIsell.map(item => {
        var newItem = Object.assign({}, item)
        if (!newItem.Image)
          newItem.Image = getUri(post.PostId, post.Version)
        return newItem
      })
      console.log("convertIsell isellModify = " + JSON.stringify(isellModify))
      return isellModify
    }
    console.log("convertIsell newIsell = " + JSON.stringify(newIsell))

    return newIsell
  }

  componentWillReceiveProps(nextProps) {
    // Just FYI, next will always not === prev, since it's a pointer comparison of two different immutable data structures
    // even if it is an exact copy, a copy is not ===
    // writing next.whatever !== this.props.whatever is always true
    // stop writing that

    if(nextProps.shoppableItems && nextProps.shoppableItems.fetching === false)
      this.setState({ shoppableSearch : false })

    if (isBlank(this.state.peopleText)) {
      this.setState({ peoples: nextProps.following })
    }
    else if (nextProps.users) {
      this.setState({ peoples: nextProps.users.data })
    }
    // this part is actually a constructor
    if(nextProps.post != null && !this.props.post) {
      const unwrapBBCodes = ( string ) => {
        const simplify = (BBCode) => {
          var found = BBCode.match(/\[link ([a-zA-Z]+) (\w{14}|\w{32}) ([-_a-zA-Z]+) (.*)\]/);
          return found? found[4] : false
        }
        var parts = string.split(/(\[[^]*?\])/)
        if( parts.length == 1 )
          return string
        for (var i = 0; i < parts.length; ++i) {
          let plainText = simplify(parts[i])
          if (plainText) parts[i] = plainText
        }
        return parts.join(' ')
      }

      if (this.state.type == this.EDIT) {
        let theySell = nextProps.post.TheySell.asMutable()
        theySell = theySell.filter(entry => KargoeConfig.shoppable.active || !entry.ItemId.includes('_shop'))
        const changes = {
          // we specifically do not want the utils one
          // in the future, that might make it a clickable link
          // in fact, we want absolute plain text only.
          caption: unwrapBBCodes(nextProps.post.Caption),
          userTags: nextProps.post.UserTags.asMutable(),
          theySell: theySell,
          iSells: this.convertISell(nextProps.post.asMutable()),
          donate: nextProps.post.Donate.asMutable(),
          locationId: nextProps.post.LocationId,
          locationCoord: nextProps.post.LocationCoord,
          locationName: nextProps.post.LocationName,
          song: nextProps.post.Song ? nextProps.post.Song : null,
          isLivePost : nextProps.post.StreamStatus > 0 // live stream switch pre-set according to stream status of existing post
        }
        console.log(`componentWillReceiveProps calling setState ISell ` + JSON.stringify(nextProps.post.ISell))
        console.log(`componentWillReceiveProps calling setState iSells ` + JSON.stringify(changes.iSells))
        this.setState(changes)
      }
    }
    if(nextProps.postTagDetail != null && nextProps.postTagDetail != this.props.postTagDetail) {
      // if (this.state.theySell.length > 0 && nextProps.postTagDetail.TheySell.length > 0) {
      if (this.state.theySell.length == 0 && nextProps.postTagDetail.TheySell.length > 0) {
        console.log(`componentWillReceiveProps calling asynSetTaggingTheySell with ` + JSON.stringify(nextProps.postTagDetail.TheySell))
        this.asynSetTaggingTheySell(nextProps.postTagDetail.TheySell).done()
      }
      //if (this.state.donate.length > 0 && nextProps.postTagDetail.Donate.length > 0) {
      if (this.state.donate.length == 0 && nextProps.postTagDetail.Donate.length > 0) {
        this.asynSetTaggingDonate(nextProps.postTagDetail.Donate).done()
      }
    }
  }

  handleBack = () => {
    console.log("handle back")
    
    console.tron.log(`EditPostScreen handleBack screenTitle ${this.state.screenTitle} type ${this.state.type}`)
    if (this.state.screenTitle == this.SHARING) {
      this.navigationBar.setRightNavBarButtons([
        { onPress: this.handleSave, title: I18n.t('editpost.next'), type: 'title' },
      ])
      this.navigationBar.setLeftNavBarButtons([
        { onPress: this.handleBack, title: I18n.t('editpost.back'), type: 'title' },
      ])
      this.setState({
        screenTitle: I18n.t('editpost.tagging'),
      })
    }
    if (this.state.screenTitle == this.EDITPOST) {
      this.props.navigation.goBack( )
      return
    }
    if (this.state.screenTitle == this.TAGGING || this.state.screenTitle == this.EDITPOST) {

      // if this is create post from messages screen (e.g. web telegram)
      // just do a normal navigate back, dont go back to camera
      if (this.fromMessages || this.fromWebWall) {
        this.props.navigation.goBack( )
        return
      }

      // if (this.props.navigation.state.params && this.props.navigation.state.params.onStartAgain) {
      if (this.state.type == CREATE && this.props.navigation.state.params.onStartAgain) {
        
        //console.log("edit post tagging create on start again")
        this.props.navigation.state.params.onStartAgain({ visible: true })
        // back to cam testing
        this.props.changeIndex({ indexChange: 0,  fromScreen: "editPost" })
      }
      //console.log("edit post tagging go back")
      this.resetNavigationBackToHome()

      //if (this.state.type == CREATE) console.log("edit post tagging create only")
    }
  }
  makeSureUserHasAgoraToken = () => {

    console.log("make sure user has agora token")

    if (this.state.isLivePost) { // make sure this user has an agora token if this is a live post

      if (this.props.auth && this.props.auth.user.Username) {

        // hack microservice to generate tokens and store on an s3 bucket

        let fetchUrl = 'https://agorakargoe.herokuapp.com/?username=' + this.props.auth.user.Username

        fetch(fetchUrl, {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          }
        }).then(response => {
            console.log("generate token response " + JSON.stringify(response))
            if (response) {
              response.json().then(x => {
                console.log("gen token json response " + JSON.stringify(x))
              })
            }
        }).catch(x => {
          Alert.alert(
            "Error",
            "Caution, cannot generate a live stream token for this user, live streaming may not work.",
            [
              { text: "OK", onPress: () => console.log("OK Pressed") }
            ]
          );
        })

      }

    }

  }

  convertDataToUpdate = (post) => {
    console.log("convertDataToUpate post = " + JSON.stringify(post))
    var newPost = Object.assign({}, post)
    newPost.TheySell = this.state.theySell.filter(v=>v).map(item => {
      return item
    })
    console.log("convertDataToUpate this.state.iSells = " + JSON.stringify(this.state.iSells))
    newPost.ISell = this.state.iSells.filter(v=>v).map(item => {
      item.Other = ' '
      return item
    })
    console.log("newPost.ISell = " + JSON.stringify(newPost.ISell))
    newPost.Song = this.state.song
    newPost.LocationCoord = this.state.locationCoord
    newPost.LocationName = this.state.locationName
    newPost.LocationId = this.state.locationId
    // for test of live stream
    newPost.Caption = /*!this.state.isLivePost ? */ this.state.caption /* : "be sure to watch my live stream!" */
    newPost.StreamStatus = 0 // temp web // this.state.isLivePost ? LiveBroadcastScreen.POST_STREAM_STATUS_NOT_STARTED : LiveBroadcastScreen.POST_STREAM_STATUS_NOT_A_STREAM
    
    this.makeSureUserHasAgoraToken.call(this)

    newPost.UserTags = this.state.userTags.filter(v=>v).map(item => {
      delete item.FirstName
      delete item.LastName
      delete item.Online
      delete item.UserIsFollowing
      return item
    })
    newPost.Donate = this.state.donate.filter(v=>v)
    return newPost
  }

  setMyShopMode = (enabled) => {
    this.setState({inMyShop: enabled})
  }

  discardMyShop = (ignoredPaypal) => {
    // FUTURE: better would be to delete any s3 images created...
    this.setState({inMyShop: false}, () => {this.handleSave(ignoredPaypal)})
  }

  handleSave = ignoredPaypal => {
    if (this.state.inMyShop) {
      Alert.alert(
        "Incomplete My Shop",
        "You are part way through creating a My Shop tag",
        [
          {text: `Delete`, onPress: () => this.discardMyShop(ignoredPaypal)},
          {text: `Continue`},
        ],
        { cancelable: true }
      )
      return
    }
    console.log("in handleSave screen title = " + this.state.screenTitle + " editpost = " + this.EDITPOST)
    // console.tron.log(`handleSave screenTitle ${this.state.screenTitle}`)
    let qrcode = (this.props.navigation.state.params &&
                   this.props.navigation.state.params.image) ?
                   this.props.navigation.state.params.image.barcodeOrQRScanResult : ''
    if (!qrcode) qrcode = this.props.recentBarcoderOutput
    if (this.state.screenTitle == I18n.t('editpost.tagging')) {
      this.navigationBar.setRightNavBarButtons([
        { onPress: this.handleSave, title: I18n.t('editpost.post'), type: 'title' }
      ])
      this.navigationBar.setLeftNavBarButtons([
        { onPress: this.handleBack, title: I18n.t('editpost.back'), type: 'title' }
      ])
      this.tapOnImage( )
      this.setState({
        screenTitle: this.SHARING
      })

    } else if (this.state.screenTitle == this.EDITPOST) {
      // console.tron.log(`EditPostScreen handleSave was EDITPOST`)
      console.log("EditPostScreen handleSave was EDITPOST post = " + JSON.stringify(this.props.post))

      var changes = this.convertDataToUpdate(this.props.post)
/*
      if (this.offsetY.__getValue() == 1) {
        this.hideTabbar()
      }
*/
      this.props.updatePost(changes)
      console.tron.log(`EditPostScreen handleSave called updatePost`) // not seen, maybe because 2nd log call?
      return
    } else if (this.state.screenTitle == this.SHARING) {
      // note: handleSave is often called from onPress, then ignoredPaypal is an event instead of a string, otherwise it would be booelan.
      // if((this.state.Expired || !this.state.basicPaypalReqMet) && this.state.theySell.filter(v=>v).length > 0 && ignoredPaypal !== 'ignored') {
      if((this.state.Expired) && this.state.theySell.filter(v=>v).length > 0 && ignoredPaypal !== 'ignored') {
        this.setState({ errorPayPal : true })
        return
      }
      this.state.theySell = this.state.theySell.filter(v => v)
      this.state.iSells = this.state.iSells.filter(v => v)
      this.state.userTags = this.state.userTags.filter(v => v)
      this.state.donate = this.state.donate.filter(v => v)
      //create Post

      // ***** not used / not translated (i18n)
      // if (this.props.navigation.state.params.image) {
      if( false && this.state.type === 'LINK' ) {
        console.tron.display({name: `EditPostScreen`,preview: `handleSave, LINK`,value: {navParams: this.props.navigation.state.params}})
        this.navigationBar.setRightNavBarButtons([ { onPress: ( ) => { }, title: 'Post', type: 'title' } ])
        this.api.createPost({
          Caption : this.state.caption, IsVideo : false, Song: this.state.song
        , ISell : this.state.iSells, TheySell : this.state.theySell, UserTags : this.state.userTags, Donate : this.state.donate
        , LocationCoord : this.state.locationCoord, LocationName : this.state.locationName, LocationId : this.state.locationId
        , MediaType : 'JPEG', AspectRatio : 1
        , Type : this.props.navigation.state.params.data.Type // YouTube -> 2, LinkPost -> 1
        , MiniMeta : this.props.navigation.state.params.data.MiniMeta // YouTube -> VideoId
        , Meta : this.props.navigation.state.params.data.Meta
        }).then( resp => {
          let post = resp.data.data[0]
          const { PostId, bucket, image, thumbImage } = post
          // upload image to s3
          let headers = { 'Content-Type' : 'application/octet-stream' }
          RNFetchBlob.fetch ( 'PUT', image._url, headers, this.props.navigation.state.params.data.b64 )
          .then( ( ) => {RNFetchBlob.fetch ( 'PUT', thumbImage._url, headers, this.props.navigation.state.params.data.thumb )} )
          .then( ( ) => {
            this.api.completePost ( PostId ).then(( ) => {
              console.tron.display({name: `EditPostScreen`,preview: `handleSave, nav to profile`,value: {nav: this.props.nav}})
              this.props.navigation.navigate('profile', { userId : this.props.UserId })
            }).catch(e => this.navigationBar.setRightNavBarButtons([{ onPress: this.handleSave, title: 'Post', type: 'title' } ]))
          }).catch(e => this.navigationBar.setRightNavBarButtons([{ onPress: this.handleSave, title: 'Post', type: 'title' } ]))
        }).catch(e => this.navigationBar.setRightNavBarButtons([{ onPress: this.handleSave, title: 'Post', type: 'title' } ]))
      } else if (this.state.type == CREATE || this.state.type === 'LINK') {
        const { navigation: { state: { params: { image } } } } = this.props
        //create new post
        // commenting out finalRenderedVideo check means that we are not requiring user to wait for render before posting
        if (/*!this.props.finalRenderedVideo*/!this.props.navigation.state.params.image.movieUrlAsNSString) { // image post
          console.tron.log(`handleSave, image Post: image, image`)
          const extraPostSettings = this.state.type === 'LINK' ? {
              IsVideo : false
            , MediaType : 'JPEG', AspectRatio : 1
            , Type : this.props.navigation.state.params.data.Type // YouTube -> 2, LinkPost -> 1
            , MiniMeta : this.props.navigation.state.params.data.MiniMeta // YouTube -> VideoId
            , Meta : this.props.navigation.state.params.data.Meta
          } : null
          this._createPostCamera(image, image, extraPostSettings) // this is what gets called on web for image post
        } else {
          console.tron.log(`handleSave, video Post`)
          // video or tilt video post
          // need to wait for final rendered video and all else that is needed for vid post
          this.props.progress(0) // reset for render progress
          let intervalCounter = 0

          let songs = [
            'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3',
            'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3',
            'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3',
            'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3',
            'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-5.mp3',
            'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-6.mp3',
            'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-7.mp3',
            'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-8.mp3'
          ]

          EditPostScreen.songdex = Math.floor(Math.random() * songs.length)
          
          if (Platform.OS !== 'web') {
            SoundPlayer.playUrl(songs[EditPostScreen.songdex])
            SoundPlayer.setVolume(0.1)
          }

          EditPostScreen.songdex += 1

          if (EditPostScreen.songdex > 7) EditPostScreen.songdex = 0

          var itvl = setInterval(function () {
            // recheck this every time, this was done in render() but if we
            // leave this container no more renders so have to do it here
            this.state.waitingForPost = true
            var result = { "test": "abc" }

            this.props.checkVideoRenderResults(result) // check redux store directly

            if (this.props.navigation.state.params.image &&
              this.props.navigation.state.params.image.movieUrlAsNSString &&
              (this.props.finalRenderedVideo || result.finalRenderedVideo) &&
              ((this.props.tileurl || result.tileurl) && result.tileurl != "failed") && // see RNCameraManager.m for where 'failed' is set
              (this.props.thumburl || result.thumburl)) {
                this.state.isVideoRendering = false
                if (Platform.OS !== 'web') 
                  SoundPlayer.stop()
              }
              else
              {
                 if (!(this.props.finalRenderedVideo || result.finalRenderedVideo)) console.log("still waiting for video")
                 // waiting for tile is a sign that video render may have failed when app sleeps after getting put in background mode
                 // we wait infinitely for tiles because video write failed, therefore tile generation failed
                 if (!(this.props.tileurl || result.tileurl)) console.log("still waiting for tile")
                 if (!(this.props.thumburl || result.thumburl)) console.log("still waiting for thumb")
                 if (result.tileurl == "failed") {
                    console.log("video rendering seems to have failed, no tile url")
                    // in this case lets get out of here but don't try to make a post from this 
                    this.state.isVideoRendering = false
                    this.props.progress(0) // clear the progress bar
                    clearInterval(itvl) // dont loop any more
                    // maybe send a log 
                    this.api.log('create post will fail due to video render fail, possibly due to app going to sleep in background')
                    /* bothers the users, just log to pprtrail above but leave alert code here for later testing
                    Alert.alert(
                      "Create video post failed",
                      "Video rendering has failed, possibly due to putting Kargoe into the background for too long.  Please try to re-post your video and keep Kargoe in the foreground until you see your new post on the wall!",
                      [
                        {text: I18n.t("editpost.gotIt"), onPress: () => console.log('got it pressed')},
                      ],
                      { cancelable: false }
                    )
                    */
                    return
                 }
              }

            if (!this.state.isVideoRendering) {
              clearInterval(itvl)
              if (this.alreadyPostedVideo) {
                console.log("debounce video posting to prevent multiple posts of same vid")
                return
              }
              this.alreadyPostedVideo = true
              console.log("video has been rendered, ready to post")
              this.setState({isVideoRendering: false})
              if (Platform.OS != 'web')
                SoundPlayer.stop()
              //setBadgeCount(777) // for testing tell user that video rendering is done lucky 7's
              this._createPost(this.props.navigation.state.params.image,
                this.props.navigation.state.params.image,
                this.props.navigation.state.params.image.uri,
                (this.props.thumburl || result.thumburl),
                (this.props.tileurl || result.tileurl),
                (this.props.finalRenderedVideo || result.finalRenderedVideo))
            }
            // if long video render fails in background this will be stuck in this loop
            // can we detect a fail?
            
            console.log("waiting for video render this.props.updatePostProgress = " + this.props.updatePostProgress)
            // kind of a fake progress bar just to show something is going on but not accurate in terms of actual % done
            // the full slow render already does this so make sure we don't go backwards

            // only do the fake forward progress for fast render which we dont have feedback from yet
            // if progress is already being updated by a real render, use it as is
            // otherwise, progress bar goes back and forth during real video render
            // see PostsSagas.js first 50% is reserved for video rendering (was 20%)
            const maxRenderProgress = 0.5
            if (this.props.updatePostProgress <= maxRenderProgress) {
              this.state.videoRenderProgress += 0.005;
              intervalCounter += 1
              let actualProgress = maxRenderProgress * (Math.log10(intervalCounter)/3)
              // just wrap for long vid
              // if (this.state.videoRenderProgress >= maxRenderProgress) this.state.videoRenderProgress = maxRenderProgress; // just pin at 0.5 for now
              console.log("bump video render progress")
              this.props.progress(actualProgress /*this.state.videoRenderProgress*/)
            }

          }.bind(this), 1000)

          // probably do this a better way direct?
          console.tron.display({name: `EditPostScreen`,preview: `handleSave, Video goBack`,value: {nav: this.props.nav}})
          this.props.navigation.goBack()
          // you can't put it twice, we could have been on home screen

        }

      } else {
        // repost
        const caption = /*!this.state.isLivePost ? */ this.state.caption /* : "be sure to watch my live stream!" */
        const streamStatus = 0 // temp web this.state.isLivePost ? LiveBroadcastScreen.POST_STREAM_STATUS_NOT_STARTED : LiveBroadcastScreen.POST_STREAM_STATUS_NOT_A_STREAM
        var copyPost = Object.assign({}, this.props.post.asMutable(),
          { TimeStamp : getTimeStamp ( ), Caption : caption, Song : this.state.song
          , LocationId : this.state.locationId, LocationName : this.state.locationName, LocationCoord : this.state.locationCoord
          , UserTags : this.state.userTags, ISell: this.state.iSells, TheySell : this.state.theySell, Donate : this.state.donate
          , StreamStatus: streamStatus
          })
        this.props.repostAction(copyPost)
        console.tron.display({name: `EditPostScreen`,preview: `handleSave, Repost goBack`,value: {nav: this.props.nav}})
        // this.props.navigation.goBack( )
        this.resetNavigationBackToHome()
      }

    }
  }

  resetNavigationBackToHome() {
    this.props.navigation.dispatch(NavigationActions.reset({
        index: 0,
        key: null,
        actions: [NavigationActions.navigate({ routeName: 'home', params: { isScroll : true } })]
    }))
  }

  setAlertMessage(message) {
    // alertView causes keyboard problems
    this.setState({alertMessage: message})
  }

  clearAlertMessage() {
    this.setAlertMessage(``)
  }

  setErrorMessage(message) {
    this.setState({errorMessage: message})
  }

  clearErrorMessage() {
    this.setErrorMessage(``)
  }

  componentDidUpdate(prevProps, prevState) {
    console.tron.display({name: `editPost`, preview: `componentDidUpdate`, value: {firstCallComponentDidUpdate: this.firstCallComponentDidUpdate, haveOffer: this.state.offer != null, prevState, state: this.state}})
    if (this.firstCallComponentDidUpdate)
      this.firstCallComponentDidUpdate = false

    if (this.props.user.user && this.props.user.user.UserId == this.props.UserId) {
      if (!this.state.userLoaded) {
        console.tron.log(`editPost, componentDidUpdate, loaded user`)
        const { user } = this.props.user
        const isStandardUser = false // user.UserKind == 100 // disabled until ExpressCheckout complete fixed
        const havePaypal = user.PaypalEmail.trim().length > 0
        const basicPaypalReqMet = isStandardUser && havePaypal
        this.setState({ userLoaded: true, user: user, isStandardUser: isStandardUser, havePaypal: havePaypal, basicPaypalReqMet: basicPaypalReqMet })
      }
    }

    if(prevState.peopleText !== this.state.peopleText && !isBlank(this.state.peopleText)){
      this.props.searchUser({ limit: 100, user: this.state.peopleText, isSearch: true })
    }
    if (this.state.arrayActive !== prevState.arrayActive) {
      if (this.state.arrayActive.some(e => e === true) && this.offsetY.__getValue() == 1) {

      } else {
        this.animate()
      }
    }
    if (prevProps.posts.updatePostSuccess != this.props.posts.updatePostSuccess) {
      console.tron.log(`editPost, componentDidUpdate, posts.updatePostSuccess timestamp changed, goBack`)
      // const a = 5 / 0
      this.props.navigation.goBack( )
      // const backAction = NavigationActions.back(null)
      // this.props.navigation.dispatch(backAction)
    }

    if (prevProps.charity.modified != this.props.charity.modified) {
      console.tron.display({name: `editPost`, preview: `ComponentDidUpdate charities`, value: {charity: this.props.charity}})
      this.setState({charities: deepClone(this.props.charity.charities)}, this.autoAddDonateTagForBarCode)
    }

    if (prevProps.kargoeTag.modified != this.props.kargoeTag.modified) {
      if (this.expectingTags) {
        this.endorseSearch.items = deepClone(this.props.kargoeTag.kargoeTags)
        this.expectingTags = false
        this.setState({modified: Date.now()})
      }
      else if (this.state.qrcode) {
        const items = this.props.kargoeTag.kargoeTags
        console.tron.display({name: `editPost`, preview: `ComponentDidUpdate kargoeTag`, value: {items}})
        if (items.length == 1) {
          const item = items[0]
          if (item.Codes.includes(this.state.qrcode)) {
            console.tron.log(`editPost ComponentDidUpdate endorsing from qrcode`)
            this.addProductEndorseCaption(item)
          }
        }
      }
    }

    if (prevProps.coupon.getOffer.modified != this.props.coupon.getOffer.modified) {
      console.tron.log("editPost, componentDidUpdate, getOffer modified is different")
      let newOffer = this.props.coupon.getOffer
       if (newOffer.phase === 'success') {
         const offer = newOffer.record
         console.tron.log("setting state for get offer in edit post screen, record = " + JSON.stringify(offer))
         if (typeof offer.UserKind == 'undefined')
           this.setErrorMessage(`QR Code is for an invalid Offer, missing UserKind.`)
         else if (offer.UserKind == USER_KIND.MERCHANT)
           this.setErrorMessage(`QR Code is for an Offer from a Merchant, which is invalid.`)
         else if (offer.UserKind == USER_KIND.CHARITY) {
           this.setState({offer})
         }
       }
       // need similar error handling as in post wall base
       else if (newOffer.phase === 'error' && newOffer.error) {
        // if no nicely printable error detail, dump the whole thing so we can debug
        let strToPrint = newOffer.error.detail || JSON.stringify(newOffer.error)
        strToPrint = strToPrint + ' ... Look around for more Kargoe QR codes for more special offers!'
        let title = "👎"
        if (strToPrint.match("expired")) title = "QR code expired"
        this.setErrorMessage(strToPrint)
      }
      else
        this.setErrorMessage("This offer for this QR code is unknown")
    }
    if (prevProps.coupon.getVendor.modified != this.props.coupon.getVendor.modified) {
      console.tron.log("editPost, componentDidUpdate, getVendor modified is different")
      const vendor = this.props.coupon.getVendor
      const user = vendor.record
      if (vendor.phase === 'success') {
        console.tron.log("editPost, componentDidUpdate, record = " + JSON.stringify(user))
        this.searchOptions = {
          UserId: user.UserId
        }
        this.props.shoppableCatalogSearch('', 0, 100, this.searchOptions)
        this.setState({vendor: user})
        this.setAlertMessage(`Endorse an item from ${user.StoreName} and share the Post to get a coupon.`)
      }
      else if (vendor.phase === 'error' && vendor.error) {
        // if no nicely printable error detail, dump the whole thing so we can debug
        let strToPrint = vendor.error.detail || JSON.stringify(vendor.error)
        strToPrint = strToPrint + ' ... Look around for more Kargoe QR codes for more special offers!'
        let title = "👎"
        if (strToPrint.match("expired")) title = "QR code expired"
        this.setErrorMessage(strToPrint)
      }
      else {
        console.tron.display({name: `editPost`, preview: `getVendor unknown state`, value: {vendor}})
        this.setErrorMessage("The vendor for this QR code is unknown")
      }
    }
    if (prevProps.coupon.vendorOffers.modified != this.props.coupon.vendorOffers.modified) {
      console.tron.log("in prev state check vendorOffers modified is different")
       if (this.props.coupon.vendorOffers.phase === 'success' && this.props.coupon.vendorOffers.list.length) {
         let validOffers = []
         const offers = this.props.coupon.vendorOffers.list
         const yyyyMMddNow = new Date().toISOString().slice(0, 10)
         for (let i = 0; i < offers.length; i++)
          if (offers[i].GoodFrom <= yyyyMMddNow && offers[i].GoodUntil >= yyyyMMddNow)
            validOffers.push(offers[i])
         if (validOffers.length) {
           console.tron.display({name: `editPost`, preview: `setting state for vendorOffers`, value: {validOffers}})
           this.setState({offer: validOffers[0], vendorOffersUserId: this.props.coupon.vendorOffers.UserId, vendorOffers: validOffers})
         }
         else
          console.tron.log(`editPost: no valid offer for today: ${yyyyMMddNow}`)
       }
    }
    if (prevState.offer == null && this.state.offer) {
      console.tron.log(`componentDidUpdate got offer`)
      this.autoAddDonateTagForBarCode()
    }
    if (prevState.vendor == null && this.state.vendor) {
    }

    if (prevState.screenTitle != this.state.screenTitle && this.state.screenTitle === this.SHARING && !this.alreadyDisplayedSharingAlert) {
      console.tron.log(`EditPostScreen ComponentDidUpdate Alert share this post to Instagram`)
      // when alert is dismissed, it re-renders and messes things up, drat
      // it seems to be redispalying UI items from TAGGING not SHARING, what?
      // display this after a delay to avoid interfering w/ the screen anims
      // this.setState({showQRAlert: true})
      if (this.state.offer) {
        this.alreadyDisplayedSharingAlert = true
        const offer = this.state.offer
        this.setAlertMessage(`${I18n.t("editpost.shareToGet")} ${offer.Description} at ${offer.VendorName}`)
      }
      if (this.state.vendor) {
        this.alreadyDisplayedSharingAlert = true
        const vendor = this.state.vendor
        this.setAlertMessage(`${I18n.t("editpost.shareToGetCoupon")} ${vendor.StoreName}`) // StoreName?
      }
    }
  } // componentDidUpdate

  autoAddDonateTagForBarCode = () => {
    const charityCount = this.props.charity.charities && this.props.charity.charities.length ? this.props.charity.charities.length : 0
    console.tron.log(`editPostScreen autoAddDonateTagForBarCode charityCount ${charityCount}, offer: ` + JSON.stringify(this.state.offer))
    if (this.state.offer && this.state.offer.CharityAmount && charityCount) {
      const offer  = this.state.offer
      const parts  = offer.OfferId.split('-')
      const UserId = parts[0]
      const charities = this.props.charity.charities
      // this.props.charity.charities
      let charityIndex = -1
      for (let i = 0; i < charities.length; i++)
        if (charities[i].CharityId == UserId) {
          charityIndex = i
          break
        }
      if (charityIndex >= 0) {
        const charity = charities[charityIndex]
        const donations = this.state.donate
        let haveDonationAlready = false
        for (let i = 0; i < donations.length; i++)
          if (donations[i].CharityId == UserId) {
            haveDonationAlready = true
            break
          }
        console.tron.log(`autoAddDonateTagForBarCode charityIndex: ${charityIndex} haveDonationAlready: ${haveDonationAlready}`)
        if (!haveDonationAlready) {
          console.log("charity = " + JSON.stringify(charity))
          this.charityAdded = charity // for later use in watermarking
          const newDonateTag = Object.assign({}, charity, {
            Amount: offer.CharityAmount,
            Left: 15,
            Top: 15,
            DonationId: 10 // ???
          })
          this.setState({donate: donations.concat(newDonateTag)})
          // only do this hide tab bar if we added the QR code later (in charity tab)
          // otherwise we try to hide the tab bar during initial display of edit post screen and it goes kaflooey (technical term)
          /* this conflicts w/ keyboard up state which is default upon entry to this screen, tab bar goes crazy
            this.hideTabbar()
          */
          console.tron.display({ name: `editPost`, preview: `autoAddDonateTagForBarCode`, value: { offer, UserId, charities: this.props.charity.charities, donationTags: this.state.donate, newDonateTag } })
          this.setAlertMessage(I18n.t("editpost.tagAdded"))
        }
      } // charityIndex
      else
        console.tron.log(`autoAddDonateTagForBarCode the offer was not from a charity user`)
    } // CharityAmount
  } // autoAddDonateTagForBarCode
  
  deactivateTabs = () => {
    Keyboard.dismiss()
    let arrayActive = this.state.arrayActive.slice()
    for (let i = 0; i < arrayActive.length; i++)
        arrayActive[i] = false
    this.setState({ arrayActive: arrayActive })
  }

  onPressIcon = (index) => {
    console.tron.log(`on press icon ${index}`)
    if (index == ENDORSE)
      this.searchEndorse(this.state.endorseText)
    this.setState({
      priceTop: 0,
      priceState: 0,
      currencyState: '',
    })
    Keyboard.dismiss()
    if (index == MYSHOP) {
      const missingPaypal = this.state.userLoaded && this.state.isStandardUser ? !this.state.havePaypal : this.state.Expired
      console.tron.display({ name: `editPost`, preview: `onPressIcon`, value: { missingPaypal: missingPaypal, state: this.state } })
      if (false && missingPaypal) {
        this.alert.showModal()
        return
      }
    }
    if (index == MUSIC) {
      console.tron.log(`calling musicSearch from onPressIcon`)
      this.props.searchMusic(this.state.musicText)
    }

    var arrayActive = this.state.arrayActive.slice()

    for (var i = 0; i < arrayActive.length; i++) {
      if (i == index) {
        arrayActive[i] = !arrayActive[i]
      } else {
        arrayActive[i] = false
      }

    }


    this.setState({
      peoples : this.props.following,
      arrayActive: arrayActive,
      peopleText : ""
    })

  }

  searchEndorse = (rawText) => {
      const text = rawText.trim()
      console.tron.log(`searchEndorse: ${text}`)
      this.setState({
          endorseText: rawText
      })
      if (this.endorseSearch.search != text) {
          console.tron.log(`searchEndorse clearing items`)
          this.endorseSearch.search = text
          this.endorseSearch.items = []
          if (text != '') { // otherwise we just use the most recent list of items, the default
              if (this.timeout) { clearTimeout(this.timeout) }
              this.timeout = setTimeout(() => {
                  console.tron.log(`searchEndorse delayed search: ${text}`)
                  this.setState({ shoppableSearch : true })
                  this.props.shoppableCatalogSearch(text, 0, 100, this.searchOptions)
                  this.timeout = null
              }, 1000)
          }
      }
  }

  showProductDetail = (item) => {
    console.tron.display({
      name: `showProductDetail`,
      preview: `item`,
      value: {
        item: item
      }
    })
    // this.setState({ productDetail: item })
    this.props.navigation.navigate('product', { item })
  }
  findOpenSpace = (dragRef) => {
    console.tron.log(`findOpenSpace, dragRef.layout ${JSON.stringify(dragRef.layout)}`)
    let layout = dragRef.layout
    const putAbove = originLayout => {
      return { x : originLayout.x, width : layout.width, height : layout.height
             , y : originLayout.y - layout.height - 10 }
    }
    const putRight = originLayout => {
      return { y : originLayout.y, width : layout.width, height : layout.height
             , x : originLayout.x + originLayout.width + 10 }
    }
    const putBelow = originLayout => {
      return { x : originLayout.x, width : layout.width, height : layout.height
             , y : originLayout.y + originLayout.height + 10 }
    }
    const putLeft = originLayout => {
      return { y : originLayout.y, width : layout.width, height : layout.height
             , x : originLayout.x - layout.width - 10 }
    }

    const layoutRelativeTo = (foreignDragRef) => {
      if (!foreignDragRef || !foreignDragRef.layout) return false
      // if( foreignDragRef.random === dragRef.random ) return false
      let above = putAbove(foreignDragRef.layout)
      if( ! this.isOverlappingTag({ layout : above }) ) return above
      let right = putRight(foreignDragRef.layout)
      if( ! this.isOverlappingTag({ layout : right }) ) return right
      let below = putBelow(foreignDragRef.layout)
      if( ! this.isOverlappingTag({ layout : below }) ) return below
      let left = putLeft(foreignDragRef.layout)
      if( ! this.isOverlappingTag({ layout : left }) ) return left
      return false
    }

    var open = layoutRelativeTo(dragRef)
    if( open !== false ) return open

    for( var i = 0 ; i < this.tagRefs['theysell'].length ; ++ i ) {
      var open = layoutRelativeTo(this.tagRefs['theysell'][i])
      if( open !== false ) return open
    }
    for( var i = 0 ; i < this.tagRefs['isell'].length ; ++ i ) {
      var open = layoutRelativeTo(this.tagRefs['isell'][i])
      if( open !== false ) return open
    }
    for( var i = 0 ; i < this.tagRefs['user'].length ; ++ i ) {
      var open = layoutRelativeTo(this.tagRefs['user'][i])
      if( open !== false ) return open
    }
    for( var i = 0 ; i < this.tagRefs['donate'].length ; ++ i ) {
      var open = layoutRelativeTo(this.tagRefs['donate'][i])
      if( open !== false ) return open
    }

    return layout // the screen is full, just let it be
  }
  isOverlappingTag = (dragRef) => {
    console.log(`isOverlappingTag, dragRef.layout ${JSON.stringify(dragRef.layout)}`)
    // check bounds
    if( dragRef.layout.x < 0 ) return "too far left"
    if( dragRef.layout.x > width - dragRef.layout.width ) return "too far right"
    const aspectRatio = this.state.naturalAR ? this.state.naturalAR : 1
    const imageHeight = aspectRatio < 1 ? 0.8 * width/aspectRatio : width/aspectRatio
    if( dragRef.layout.y + dragRef.layout.height > imageHeight ) return "top too far down"
    // if( dragRef.layout.y+dragRef.layout.height < 0 ) return "too far up"
    if( dragRef.layout.y < 0 ) return "too far up"
    if( dragRef.layout.x < 205 && dragRef.layout.y < 38) return "in stream control"

    const intersects = (A,B) => {
      if (!A || !B) return false
      if( A.random === B.random && A.random && B.random ) return false
      if (!A.layout || !B.layout) return false // crash patch, edit post
      let a = A.layout, b = B.layout
        , bx2 = b.x+b.width, ax2 = a.x+a.width
        , by2 = b.y+b.height, ay2 = a.y+a.height
        , overlapX = ( b.x >= a.x && b.x <= ax2 ) || ( bx2 >= a.x && bx2 <= ax2 )
        , overlapY = ( b.y >= a.y && b.y <= ay2 ) || ( by2 >= a.y && by2 <= ay2 )
      return overlapX && overlapY
    }
    const overlaps = a => b => intersects(a,b) || intersects(b,a)
    const overlapsLayout = overlaps(dragRef)
    let phase = 'theysell'
    if( this.tagRefs['theysell'].filter(overlapsLayout).length > 0 ) return "theysell"
    if( this.tagRefs['isell'].filter(overlapsLayout).length > 0 ) return "isell"
    if( this.tagRefs['user'].filter(overlapsLayout).length > 0 ) return "user"
    if( this.tagRefs['donate'].filter(overlapsLayout).length > 0 ) return "donate"
    return false
  }
  addProductEndorseCaption = (data) => {
    console.tron.display({name: 'add TheySell', preview: `addProductEndorseCaption`, value: {item: data}})
    let newData = {}
    newData.Left = convertToPercent(coordinateDefault, width, heightImage).xPercent
    newData.Top = convertToPercent(coordinateDefault, width, heightImage).yPercent
    newData.ItemId = data.ItemId
    newData.Title = data.Title
    newData.PriceMin = data.PriceMin
    newData.PriceMax = data.PriceMax
    if (data.Currency)
      newData.Currency = data.Currency
    newData.Image = data.ImageUrls && data.ImageUrls[0]
    if (data.Shoppable)
      newData.MerchantId = data.Shoppable.MerchantId
    if (data.isExternal) {
      newData.External   = data.External
      newData.ProductUrl = data.ProductUrl
      newData.ProductId  = data.ProductId
    }
    console.log(`addProductEndorseCaption product ` + JSON.stringify(newData))
    let theySells = this.state.theySell.slice()
    console.log("theySells = " + JSON.stringify(theySells))
    const checkForIt = theySells.findIndex((x) => newData.ItemId === x.ItemId)
    console.log("checkForIt = " + checkForIt)
    if (checkForIt < 0) {// only add it if not found in the list already
      theySells.push(newData)
      if (this.offsetY.__getValue() == 1) {
        this.hideTabbar( )
      }
     
     // this.searchEndorse(this.state.endorseText) // ''
     this.setState({ theySell: theySells })
    } else {
      Alert.alert(
        "Product already endorsed!",
        "You have already added this product to this post, please pick another product!",
        [
          { text: "OK", onPress: () => console.log("OK Pressed") }
        ]
      );
    }
  }
  getBarcoder = ({barcoder}) => {
    console.tron.log("getBarcoder endorser barcoder output = " + barcoder)
    if (barcoder) {
      const qrCodeDetails = parseQRCode(barcoder)
      if (qrCodeDetails.OfferId)
        this.setState({scanKind: 'offer'})
      if (qrCodeDetails.VendorId)
        this.setState({scanKind: 'vendor'})
      if (qrCodeDetails.OfferId)
        this.props.getOffer(qrCodeDetails.OfferId, null)
      else if (qrCodeDetails.VendorId)
        this.props.getVendor(qrCodeDetails.VendorId)
      else if (qrCodeDetails.ItemId) {
        this.expectingTags = true
        this.props.getSearchTag({ search: qrCodeDetails.ItemId, filter: "CODE_LOOKUP", limit: 100 })
      }
      else
        console.tron.log(`barcode format not recognized`)
    }
  }
  getBarcoderDonation = ({barcoder}) => {
    console.tron.log("getBarcoderDonation donation barcoder output = " + barcoder)
    this.state.qrcode = barcoder // dont use setState, no need to trigger render
    const qrCodeDetails = parseQRCode(barcoder)
    if (qrCodeDetails.OfferId)
      this.setState({scanKind: 'offer'})
    if (qrCodeDetails.VendorId)
      this.setState({scanKind: 'vendor'})
    if (qrCodeDetails.OfferId)
      this.props.getOffer(qrCodeDetails.OfferId, null)
    else if (qrCodeDetails.VendorId)
      this.props.getVendor(qrCodeDetails.VendorId)
    else
      this.setErrorMessage("Sorry, Kargoe doesnt understand this QR code.  Look around for another Kargoe QR code and try again!")
  }
  goToBarcoder = () => {
    this.props.navigation.navigate('barCoder', { getBarcoder : this.getBarcoder })
  }
  goToBarcoderDonation = () => {
    this.props.navigation.navigate('barCoder', { getBarcoder : this.getBarcoderDonation })
  }
  testBuy = (item) => {
    const itemData = Object.assign({}, item, {isISell: false})
    console.tron.log("EditPostScreen testBuy item: " + JSON.stringify(itemData))
    const shoppable = typeof itemData.Shoppable !== 'undefined'
    if (shoppable) {
      console.tron.log("EditPostScreen testBuy Shoppable")
      this.props.navigation.navigate('shoppableVariant', {
        post: {
          PostId: 'express',
          UserId: null,
          Username: 'n/a',
          Donate: [],
          iSell: [],
          TheySell: [
              {
                ItemId: itemData.ItemId
              },
          ],
        },
        tag:  {
          ItemId: itemData.ItemId
        },
        item: itemData,
      })
    }
    else {
      // Standard Shopify TheySell
      console.tron.log("EditPostScreen testBuy Shopify TheySell, not supported")
      const orderConfParams = {
        data: itemData,
        meta: {},
        api: {
          PostId: 'express',
          TagId: itemData.ItemId,
        },
        tag: false
      }
      this.props.navigation.navigate('orderConfirm', orderConfParams) // boom, because we haven't done a pre-flight
    }
  }
  showEndorse = (products) => {
    // products endorseDataProvider
    this.endorseDataProvider = this.endorseDataProvider.cloneWithRows(products)
    console.tron.display({
      name: `showEndorse`,
      preview: `endorseDataProvider`,
      value: {
        products: products,
        endorseDataProvider: this.endorseDataProvider
      }
    })
    const userCurrency = typeof this.props.user.Currency != 'undefined' ? this.props.user.Currency : 'USD'
    return (
      <EditPostEndorseV2
        value={this.state.endorseText}
        addProductCaption={this.addProductEndorseCaption}
        showProductDetail={this.showProductDetail}
        onChangeText={this.searchEndorse}
        products={products}
        onPressBarcoder={this.goToBarcoder}
        dataProvider={this.endorseDataProvider}
        loadMoreData={this.loadMoreEndorseData}
        searching={this.state.shoppableSearch}
        testBuy={this.testBuy}
        exchangeRates={this.props.exchangeRates}
        userCurrency={userCurrency}
      />
    )
  }

  showProductDetail = (item) => {
    console.tron.display({
      name: `showProductDetail`,
      preview: `item`,
      value: {
        item: item
      }
    })
    // this.setState({ productDetail: item })
    this.props.navigation.navigate('product', { item })
  }
  hideTabbar = (callback) => {
    var arrayActive = this.state.arrayActive.slice()
    console.log("hideTabbar arrayActive = " + JSON.stringify(arrayActive))

    for (var i = 0; i < arrayActive.length; i++) {
      arrayActive[i] = false
    }

    this.setState({
      arrayActive
    })
  }
  getUserTag = (data) => {
    var newData = {}
    newData.Left = convertToPercent(coordinateDefault, width, heightImage).xPercent
    newData.Top = convertToPercent(coordinateDefault, width, heightImage).yPercent
    newData.Username = data.Username
    newData.UserId = data.UserId
    return newData
  }
  onPeopleAvatar = (data) => {
    let newData = this.getUserTag(data)

    console.tron.display({
      name: `onPeopleAvatar`,
      preview: ``,
      value: {
        state: newData
      }
    })

    var arrayUserTags = this.state.userTags.slice()
    arrayUserTags.push(newData)
    this.hideTabbar()
    this.setState({
      userTags: arrayUserTags,
    })

  }
  searchPeople=(user)=>{


    if(!isBlank(user)){
      this.setState({
        peopleText: user
      })

    }else{


      this.setState({
        peopleText: "",
        peoples : this.props.following
      })
    }

  }
  showPeople = (people) => {
    return (
      <EditPostPeople
      onClear = {() =>{
        this.setState({
          peopleText: "",
          peoples : this.props.following
        })
      }}
        value={this.state.peopleText}
        onChangeText={(text) => this.searchPeople(text)}
        onAvatarPress={this.onPeopleAvatar}
        people={people}
      />
    )
  }

  addSong = (data) => {
    console.tron.display({name: 'addSong', preview: `details`, value: {data}})
    this.hideTabbar( )
    this.setState({ song: data })
  }

  searchMusic = (song) => {
    this.setState({
      songText: song,
    })
    if (song.length > 2)
      this.props.searchMusic(song)
  }

  onMusicSearch = () => {
    this.props.searchMusic(this.state.songText)
  }

  showMusic = (appleMusic) => {
    return (
      <EditPostMusic
        onClear = {() =>{
          this.searchMusic('')
          this.props.searchMusic('')
        }}
        value={this.state.musicText}
        onChangeText={(text) => this.searchMusic(text)}
        onSearch={this.onMusicSearch}
        songs={appleMusic.data}
        addSong={this.addSong}
        currentSong={this.state.song}
      />
    )
    // this.props.appleMusic.data ...
    if (appleMusic.data == null)
      return (
        <Text>{`Loading...`}</Text>
      )
    return (<View>
      {appleMusic.data.map((detail, index) => {
        return (
          <View>
            <Text>{detail.song}</Text>
          </View>)
      })}
      </View>)
  }

  showLocation = (user) => {
    return (
      <LocationComponent
        showUserMaker={true}
        isSearchbar
        locationId={this.state.locationId}
        locationCoord={this.state.locationCoord}
        locationName={this.state.locationName}
        onChangeAddress={this.onChangeAddress}
      />

    )
  }
  onChangeAddress = (locationId, locationCoord, locationName) => {
    console.log("onChangeAddress locationName = " + locationName)
    this.setState({
      locationId: locationId,
      locationCoord: locationCoord,
      locationName: locationName
    })

    this.onPressIcon(4)
  }
  addTagDonation = (item) => {
    console.tron.display({name: 'addTagDonation', preview: `item maybe FundMe`, value: {item}}) // vendorOffers

    const missingPaypal = this.state.userLoaded && this.state.isStandardUser ? !this.state.havePaypal : this.state.Expired
    console.tron.display({ name: `editPost`, preview: `addTagDonation`, value: { missingPaypal: missingPaypal, state: this.state } })
    if (missingPaypal && item.FundMe) {
      setTimeout(() => this.alertFundMe.showModal(), 1)
      return
    }

    let newItem = Object.assign({}, item)
    newItem.Left = convertToPercent(coordinateDefault, width, heightImage).xPercent
    newItem.Top = convertToPercent(coordinateDefault, width, heightImage).yPercent
    newItem.DonateId = 10
    newItem.Currency = 'USD'
    // newItem.FundMe = true // Test, for now, currency will probably be different as well...  Username field?  Changes?
    if (this.state.arrayActive[DONATATION])
      this.hideTabbar()
    let donate = this.state.donate.concat()
    donate.push(newItem)
    console.tron.display({name: 'addTagDonation', preview: `donate after newItem`, value: {donate}})
    this.props.vendorOffers(newItem.CharityId)
    this.setState({ donate })
  }
  searchDonate = (text) => {
    if (text !="") {

      let charityFinds =    this.props.charity.charities.filter(charity =>{

        if(charity.CharityName.toLowerCase().includes(text.toLowerCase())){
          return charity
        }
       })
       this.setState({
        donationText: text,
        charities: deepClone(charityFinds)

      })
    }else{
      this.setState({
        donationText:"",
        charities: deepClone(this.props.charity.charities)

      })
    }

  }
  donatation = (charities) => {
    const missingPaypal = this.state.userLoaded && this.state.isStandardUser ? !this.state.havePaypal : this.state.Expired
    const currency = 'USD'
    return (
      <EditPostDonation
        donations={this.state.donate}
        currency={currency}
        value={this.state.donationText}
        onChangeText={this.searchDonate}
        addTagDonation={this.addTagDonation}
        charities={charities}
        onPressBarcoder={this.goToBarcoderDonation}
        authUser={this.props.auth}
        hasPaypal={!missingPaypal}
        makeGoFundMeEntry={this.makeGoFundMeEntry}
      />

    )
  }
  getDimensionSharing = ({ x, y, width, height }) => {
    this.setState({
      shareHeight: height
    })
  }
  onCustomFrame = (data, index, type, layout) => {
    // layout is { x, y, width, height } in points
    switch (type) {
      case PEOPLE:
        var userTags = this.state.userTags.concat()
        userTags[index] = data
        this.setState({ userTags: userTags })
        break

      case MUSIC:
        // haven't a clue...
        break;

      case MYSHOP:
        var iSells = this.state.iSells.concat()
        iSells[index] = Object.assign({}, data, {Image: iSells[index].Image}) // fix for _DEFAULT_ vs converted to proper url for dragcomponent
        this.setState({ iSells: iSells })
        break

      case ENDORSE:
        var theySell = this.state.theySell.concat()
        theySell[index] = data
        this.setState({ theySell: theySell })
        break

      case DONATATION:
        var donates = this.state.donate.concat()
        donates[index] = data
        this.setState({ donate: donates })
        break

      default: break
    }

  }
  getPostParams = (imageFile) => {

    const post = {
      "Caption": /*!this.state.isLivePost ? */ this.state.caption, /* : "be sure to watch my live stream!", */
      "StreamStatus" : 0, // temp web this.state.isLivePost ? LiveBroadcastScreen.POST_STREAM_STATUS_NOT_STARTED : LiveBroadcastScreen.POST_STREAM_STATUS_NOT_A_STREAM,
      "Song": this.state.song,
      "LocationId": this.state.locationId,
      "LocationName": this.state.locationName,
      "LocationCoord": this.state.locationCoord,
      "UserTags": this.state.userTags,
      "ISell": this.state.iSells,
      "TheySell": this.state.theySell,
      "Donate": this.state.donate,
      // go back to orig image or vid aspect ratio jun 30 2021
      "AspectRatio": true /*!this.state.isLivePost*/ ? imageFile.width / imageFile.height : 640/1138, // the AR that the live stream is saved in, if it is saved
      "Origin": "50,50", // TODO
      "MediaType": MEDIA_TYPE.JPEG,
    }
    return post
  }
  _createPost = (imageFile, thumbFile, imageURL, thumbURL, tilesURL, videoURL) => {
    const post = this.getPostParams(imageFile)
    console.tron.display({
      name: `_createPost`,
      preview: ``,
      value: {
        state: post,
        imageURL: imageURL
        , thumbURL: thumbURL
        , tilesURL: tilesURL
        , videoURL: videoURL
      }
    })
    // this does not get called w/ a normal create post via image
    // this is for video post
    console.log("create post loc 1")
    console.log('ready to make sure user has agora token loc 1')
    this.makeSureUserHasAgoraToken.call(this)

    /* orig image only post
    const files = [
      {
        'kind': 'thumbImage',
        'size': thumbFile.base64.length, // 1
        'base64': thumbFile.base64,
        'uri': thumbFile.uri
      },
      {
        'kind': 'image',
        'size': imageFile.base64.length, // 4,
        'base64': imageFile.base64,
        'uri': thumbFile.uri
      },
    ]
    */

    //console.log("prepping file list, imageFile.uriThumb = " + imageFile.uriThumb);
    //console.log("prepping file list, imageFile.uri      = " + imageFile.uri);

    /* after kargoe cam and new upload from file method, integration, this is for an image post */
    var files = [
      {
        'kind': 'thumbImage',
        'size': null /*thumbFile.base64.length*/, // 1
        'base64': null /*thumbFile.base64*/,
        'uri': imageFile.uriThumb // pull from orig
      },
      {
        'kind': 'image',
        'size': null /*imageFile.base64.length*/, // 4,
        'base64': null /*imageFile.base64*/,
        'uri': imageFile.uri
      },
    ]

    // for videos and tilt videos
    if (videoURL) {
      post.MediaType = 'MP4'
      if (imageFile.is3DMovie === '1') post.MediaType = '3D'
      // imageURL, thumbURL, tilesURL, videoURL as args (can use first 2 for image later)
      files = [
        {
          'kind': 'thumbImage',
          'size': null /*thumbFile.base64.length*/,
          'base64': null /*thumbFile.base64*/,
          'uri': thumbURL // pull from orig
        },
        {
          'kind': 'image',
          'size': null /*imageFile.base64.length*/,
          'base64': null /*imageFile.base64*/,
          'uri': imageURL
        },
        {
          'kind': 'tileVideo',
          'size': null /*imageFile.base64.length*/,
          'base64': null /*imageFile.base64*/,
          'uri': tilesURL
        },
        {
          'kind': 'video',
          'size': null /*imageFile.base64.length*/,
          'base64': null /*imageFile.base64*/,
          'uri': videoURL
        },
      ] // files for video

      // for video we had to wait for render so sharing is here also
      if (this.sharingComponent) {
        console.log("in post, should share vid to:  " + this.sharingComponent.state.currentButtonLabel)
        console.log("video url = " + videoURL)
        switch (this.sharingComponent.state.currentButtonLabel) {
          case 'instagram' :
            this.shareWithInstagram(videoURL) // works
            break;
          case 'twitter' :
            console.log('ready to share with twitter')
            this.shareWithTwitter(imageURL) // vidoeURL fail use poster for now
            console.log('done sharing with twitter')
            break;
          case 'tumblr' :
            console.log('ready to share with tumblr')
            // video local file:// seems to fail
            this.shareWithTumblr(imageURL) // unknown video support yet, use poster image for now
            console.log('done sharing with tumblr')
            break;
          case 'facebook' :

            // To check using URL (works on iOS and Android):
            console.log("ready to call app installed checker")
            AppInstalledChecker
            .checkURLScheme('fb') // omit the :// suffix
            .then((isInstalled) => {
                // isInstalled is true if the app is installed or false if not
                console.log("facebook app is installed = " + isInstalled)

                if (isInstalled)
                {
                  console.log('ready to share video with facebook')
                  // current idea
                  // need an asset-library:// url for fb not file:// url
                  // so get most recently saved video
                    CameraRoll.getPhotos({
                      first: 1,
                      assetType: 'Videos',
                    })
                    .then(r => {
                      console.log("got video url " + JSON.stringify(r))
                      if (r.edges.length > 0) {
                        const uri = r.edges[0].node.image.uri

                        console.log("vid uri " + uri)
                        this.shareMediaWithShareFacebook(uri, true) // work in progress, this will fail
                      }
                    })
                    .catch((err) => {
                      //Error Loading Images
                      console.log("camera roll error getting most recent video = " + JSON.stringify(err))
                    });

                  //this.shareMediaWithShareFacebook(videoURL) // work in progress, this will fail
                  console.log('done sharing video with facebook')
                }
                else {

                  alertView(I18n.t("editpost.facebookVideoTitle"), I18n.t("editpost.facebookVideoMsg"))

                }
            })
            .catch((err) => {
                console.log("error in checking fb app installed " + JSON.stringify(err))

            })
            break;
        }
      }
      else
         console.log("no sharing component any more for video")
    }
    // possibly introduce console.tron here
    console.log("ready to post = " + JSON.stringify(post) + " fileCount = " + files.length + " files = " + JSON.stringify(files))
    
    let emitter = new TinyEmitter() // for catching post progress

    console.log("progress emitter created in edit post screen = " + this.emitter)

    // events are emitted by background uploader in PostsSagas
    if (emitter)
      emitter.on('progress', (x) => {
        console.log("edit post screen caught progress event " + JSON.stringify(x))
        if (x) this.props.progress(x.percent)
      })

    console.log("ready to call createPost")
    this.props.createPost(post, files, emitter)  // not for web image post

    // clear the stored caption once user posts
    // we really should clear after post success but that requires more work
    /* temp remove for web 
    userDefaults.set('editPostScreenCaption', '')
    .then(data => console.log("clear user defaults success:  caption " + JSON.stringify(data)))
    */
    // clear state in case we make another post in the future
    this.setState( this.initialState )
  }
    // model after 3dot share but just pass in file url of the image or movie we are going to post
  // (note:  movies may not be supported yet by the instagram component)
  // imageMarkerFn only works for stills now so dont pass this function in for videos
  shareWithInstagram = (url, imageMarkerFn) => {
    let isVid = false
    if (url.endsWith('.mp4') || url.endsWith('.MP4')) isVid = true
    if (isVid) { // ignore flags for marking video just go straight to sahre
        theShare(url) // no watermark
        return
    }

    if (this.state.switchIsOn /*|| this.state.switchIsOnLogo*/) { // share w/ tags switch || share w/ kargoe logo switch, have to watermark
      this.setState({showTagCloseButtons : false}) // shut off X's on tags but then we need a render before capturing
      // so do this later give time for render
      setTimeout(() => {
        captureRef(this.mainContainerView, {
          format: "jpg",
          quality: 0.8
        })
        .then(
            uri => {console.log("Image to share to INSTAGRAM WITH TAGS saved to", uri)
                    // last arg optional (charityAdded)
                    console.log("this.charityAdded before imageMarkerFn = " + this.charityAdded)
                    // switches are passed in ! logic because default args are false (and args are Hide, implies default is "do not hide")
                    if (imageMarkerFn) imageMarkerFn(uri, theShare, false, this.charityAdded, /*hideTags*/!this.state.switchIsOn, /*hideLogo*/!this.state.switchIsOnLogo) // watermark
                    else theShare(uri) // no watermark
                    this.setState({showTagCloseButtons : true}) // put X's back on tags
                  }
          , error => {console.warn("Oops, snapshot for tagging share w/ tags failed", error)
                      this.setState({showTagCloseButtons : true}) // put X's back on tags
                     }
        )
      }, 100) // setTimeout
    }
    else { // do not share w/ tags
      if (imageMarkerFn) imageMarkerFn(url, theShare, false, this.charityAdded, /*hideTags*/!this.state.switchIsOn, /*hideLogo*/!this.state.switchIsOnLogo) // watermark
      else theShare(url) // no watermark
    }
    function theShare(url) {
      RNInstagramShare.createPost(
        { url: url },
        (res) => {
          console.tron.display({
            name: `RNInstagramShare`,
            preview: ``,
            value: {
              state: res
            }
          })
        },
      );
    }
  }
  shareWithTwitter = (url, imageMarkerFn) => {

    if (this.state.switchIsOn) { // share w/ tags switch

      this.setState({showTagCloseButtons : false}) // shut off X's on tags but then we need a render before capturing
      // so do this later give time for render

      setTimeout(() => {

      captureRef(this.mainContainerView, {
        format: "jpg",
        quality: 0.8
      })
      .then(
          uri => {console.log("Image to share to TWITTER WITH TAGS saved to", uri)
                  if (imageMarkerFn) imageMarkerFn(uri, theShare, false, this.charityAdded, /*hideTags*/!this.state.switchIsOn, /*hideLogo*/!this.state.switchIsOnLogo) // watermark
                  else theShare(uri) // no watermark
                  this.setState({showTagCloseButtons : true}) // put X's back on tags
                 }

                 , error => {console.warn("Oops, snapshot for tagging share w/ tags failed", error)
                             this.setState({showTagCloseButtons : true}) // put X's back on tags
                            }
      )
      }, 100) // setTimeout
    }
    else { // do not share w/ tags
      if (imageMarkerFn) imageMarkerFn(url, theShare, false, this.charityAdded, /*hideTags*/!this.state.switchIsOn, /*hideLogo*/!this.state.switchIsOnLogo) // watermarking happens async so have to do theShare later
      else theShare(url) // if no need for watermark just do it now
    }

    function theShare(url) {
      var shareOptions = {
        title: "hello from kargoe",
        url: url,
      };

      TwitterShare.tweet(shareOptions).then(result => {
        console.log("tweet success result = " + JSON.stringify(result))
        var msg = 'Tweet success'
        if (typeof result === 'array' && result.length > 0) msg = result[0]
        else if (typeof result === 'string') msg = result
        if (msg.match("cancelled")) msg = I18n.t('editpost.twitterInstalled2') // "To share from Kargoe, make sure the Twitter app is installed and you are logged in to it."

        alertView(msg, "")
      }).catch(error => { // this is not working if, say, twitter app is not installed
        // not sure if error is an object, array, or string yet...
        console.log("twitter error in edit post screen = " + JSON.stringify(error))
        alertView(error, I18n.t('editpost.twitterInstalled'))
      })
    }
  }
  shareWithTumblr = (url, imageMarkerFn) => {

      if (this.state.switchIsOn) { // share w/ tags switch
          captureRef(this.mainContainerView, {
            format: "jpg",
            quality: 0.8
          })
          .then(
              uri => {console.log("Image to share to TUMBLR WITH TAGS saved to", uri)
                      let modUrl = uri.replace(/^file:../,'')
                      console.log("ready to send to image marker url = " + uri)
                      if (imageMarkerFn) imageMarkerFn(uri, TumblrShare.postImage, true /*pathNotUrl*/) // watermarking happens async so have to do theShare later
                      else TumblrShare.postImage(modUrl) // if no need for watermark just do it now
                    }
            , error => console.warn("Oops, snapshot for tagging share w/ tags failed", error)
          )
      }
      else {
        setTimeout(function () {
          //let url = getUri(data.PostId, '')
          // if a file url we must set a path not a file url, what...
          //http://blog.tijo.me/post/140102837552/tumblr-sharing-with-the-flurry-sdk
          let modUrl = url.replace(/^file:../,'')
          console.log("ready to send to image marker url = " + url)
          if (imageMarkerFn) imageMarkerFn(url, TumblrShare.postImage, true /*pathNotUrl*/) // watermarking happens async so have to do theShare later
          else TumblrShare.postImage(modUrl) // if no need for watermark just do it now
        }, 1000)
      }


  }
  // not used here yet
  // note:  dont have link yet before post creation is done
  shareLinkWithShareFacebook = (url) => {
    //let url = getUri(data.PostId, '')
    const shareLinkContent = {
      contentType: 'link',
      contentUrl: url,
      contentDescription: '',
    };

    ShareDialog.canShow(shareLinkContent).then(
      (canShow) => {
        if (canShow) {
          return ShareDialog.show(shareLinkContent);
        }
      }
    ).then(
      (result) => {
        if (result.isCancelled) {
        } else {
        }
      },
      function (error) {
        alert('Facebook link share (tagging) fail with error: ' + JSON.stringify(error)); // we dont use link sharing any more, dont bother to translate
      }
    );
  }
  // pass in file:// url which we have anyway
  shareMediaWithShareFacebook = (url, isVideo, imageMarkerFn) => {
    console.log("media to share with fb " + url)

    if (this.state.switchIsOn) { // share w/ tags switch

      this.setState({showTagCloseButtons : false}) // shut off X's on tags but then we need a render before capturing
      // so do this later give time for render

      setTimeout(() => {

      captureRef(this.mainContainerView, {
        format: "jpg",
        quality: 0.8
      })
      .then(
          uri => {console.log("Image to share to FACEBOOK WITH TAGS saved to", uri)
                  if (imageMarkerFn) imageMarkerFn(uri, theShare, false, this.charityAdded, /*hideTags*/!this.state.switchIsOn, /*hideLogo*/!this.state.switchIsOnLogo) // watermarking happens async so have to do theShare later
                  else theShare(uri) // if no need for watermark just do it now
                  this.setState({showTagCloseButtons : true}) // put X's back on tags
                 }
        , error => {console.warn("Oops, snapshot for tagging share w/ tags failed", error)
                    this.setState({showTagCloseButtons : true}) // put X's back on tags
                   }
      )
    }, 100) // setTimeout

    }
    else {
      if (imageMarkerFn) imageMarkerFn(url, theShare, false, this.charityAdded, /*hideTags*/!this.state.switchIsOn, /*hideLogo*/!this.state.switchIsOnLogo) // watermarking happens async so have to do theShare later
      else theShare(url) // if no need for watermark just do it now
    }

    function theShare(url) {
      var shareMediaContent = {
        contentType: 'photo',
        photos: [{imageUrl: url}]
      };

      if (RegExp(/.mp4$/).test(url) || isVideo) {
        console.log('sharing video')
        shareMediaContent = {
          contentType: 'video',
          video: {localUrl: url}, // according to doc, maybe this needs to be special asset library url not ordinary file://
          //contentUrl: 'https://kargoe.com'
          //localUrl: url
        };
      }

      ShareDialog.canShow(shareMediaContent).then(
        (canShow) => {
          console.log('can show facebook content')
          if (canShow) {
            return ShareDialog.show(shareMediaContent);
          }
          else // 'Cannot share to Facebook at this time.  Make sure you have the Facebook app installed and are logged in to it.'
            alert(I18n.t('editpost.facebookError1'));
        }
      ).then(
        (result) => {
          if (result.isCancelled) {
          } else {
          }
        },
        function (error) {
          alert('Facebook media share (tagging) fail with error: ' + JSON.stringify(error));
        }
      );
    } // theShare
  }
  _createPostCamera = (imageFile, thumbFile, extraPostSettings) => {
    let qrcode = (this.props.navigation.state.params &&
                   this.props.navigation.state.params.image) ?
                   this.props.navigation.state.params.image.barcodeOrQRScanResult : ''
    if (!qrcode) qrcode = this.props.recentBarcoderOutput
    if (!qrcode) qrcode = this.state.qrcode // from charity search barcoder scanner

    console.tron.log("createPostCamera imageFile = " + JSON.stringify(Object.keys(imageFile)))

    console.log("createPostCamera imageFile = " + JSON.stringify(Object.keys(imageFile)))

    console.log("createPostCamera thumbFile = " + JSON.stringify(Object.keys(thumbFile)))

    //console.log("createPostCamera uri = " + imageFile.uri)

    //console.tron.log("createPostCamera thumbFile.uriThumb = " + thumbFile.uriThumb)

    let post = Object.assign({}, this.getPostParams(imageFile), extraPostSettings)

    let continuePostCreation = (altImageBase64) => {

      if (altImageBase64) imageFile.base64 = altImageBase64

      console.log("create post loc 2")
      console.log('ready to make sure user has agora token loc 2')
      this.makeSureUserHasAgoraToken.call(this)

      if (this.sharingComponent && this.sharingComponent.state.currentButtonLabel == 'instagram') {
        post.PostWillBeShared = true // let API know it should give you coupons
        if (this.state.offer) // qrcode
          post.OfferIdsOnCompletion = this.state.offer.OfferId // qrcode
        if (this.state.vendor)
          post.OffersFromVendorIds = this.state.vendor.UserId
      }

      console.tron.display({name: '_createPostCamera', preview: `post`, value: {post, qrcode}})

      if (!thumbFile || !thumbFile.base64Thumb) // simulator dont have thumb image just re-use full size for now
      {
        console.log("thumb logic 1")
        thumbFile = JSON.parse(JSON.stringify(imageFile))
        thumbFile.base64Thumb = thumbFile.base64
        thumbFile.uriThumb = thumbFile.uri
      }

      if (thumbFile && thumbFile.base64Thumb) {
        console.log("thumbFile.base64Thumb.length = " + thumbFile.base64Thumb.length)
        //console.log("thumbFile.uri = " + thumbFile.uri)
        //console.log("thumbFile.uriThumb = " + thumbFile.uriThumb)
      }
      else console.log("thumbFile object not defined!")

      if (imageFile && imageFile.base64Thumb) {
        console.log("imageFile.base64Thumb.length = " + imageFile.base64Thumb.length)
      }
      else console.log("imageFile object not defined!")

      const files = [
        {
          'kind': 'thumbImage',
          'size': thumbFile.base64Thumb.length, // 1
          'base64': thumbFile.base64Thumb, //
          'uri': thumbFile.uriThumb // this is critical or thumb image gets stored full size on server
        },
        {
          'kind': 'image',
          'size': imageFile.base64.length, // 4,
          'base64': imageFile.base64,
          'uri': thumbFile.uri
        },
      ]

      
      // showing as undefined when using qr code from charity
      // this is showing up
      console.log('ready to create post.OfferIdsOnCompletion = ' + JSON.stringify(post.OfferIdsOnCompletion))

      console.log('post = ' + JSON.stringify(post))
     
      console.log('ready to call createPost')
      this.props.createPost(post, files) // for web / image post

      console.log('after createPost initiated but not done')

      // clear the stored caption once user posts
      // we really should clear after post success but that requires more work
      /* not yet for web
      userDefaults.set('editPostScreenCaption', '')
      .then(data => console.log("clear user defaults success:  caption " + JSON.stringify(data)))
      */

      this.props.changeIndex({'barcoderOutput' : 'clear'}) // test to clear last saved barcode output

      // share image (see _createPost for share video)
      if (this.sharingComponent) {
        console.log("in post, should share to:  " + this.sharingComponent.state.currentButtonLabel)

        switch (this.sharingComponent.state.currentButtonLabel) {
          case 'instagram' :
            this.shareWithInstagram(thumbFile.uri, markImageWithWatermark) // see above, it is really the full image
            break;
          case 'twitter' :
            console.log('ready to share with twitter')
            this.shareWithTwitter(thumbFile.uri, markImageWithWatermark)
            console.log('done sharing with twitter')
            break;
          case 'tumblr' :
            console.log('ready to share with tumblr')
            this.shareWithTumblr(thumbFile.uri, markImageWithWatermark)
            console.log('done sharing with tumblr')
            break;
          case 'facebook' :
            console.log('ready to share with facebook')
            this.shareMediaWithShareFacebook(thumbFile.uri, false, markImageWithWatermark)
            console.log('done sharing with facebook')
            break;
        }
      }
      else
        console.log("no sharing component any more")

    } // continue post creation

    // if this is going to be a live stream post, make sure the aspect ratio of the image
    // is 9/16, add white space if not

    if (false && post.StreamStatus == LiveBroadcastScreen.POST_STREAM_STATUS_NOT_STARTED) {

      // do this locally later
      // example:  https://dummyimage.com/600x400/ffffff

      const overlay = imageFile.uri
      let position = { x: 0, y: 0 } // to do:  calc to center vertically

      Image.getSize(overlay, (widthImage, heightImage) => { 

          console.log("image size = " + widthImage + " " + heightImage)

          console.log("post.AspectRatio = " + post.AspectRatio) // width over height 

          if (Math.abs(post.AspectRatio - widthImage/heightImage) > 0.01) { // different AR

              let newHeight = Math.round(widthImage * 1138/640)

              let backgroundImage = 'https://dummyimage.com/' + widthImage + 'x' + newHeight + '/ffffff'

              position.y = (newHeight - heightImage)/2 // center vertically on background

              PhotoManipulator.overlayImage(backgroundImage, overlay, position).then(path => {

                  console.log(`Result image path: ${path}`)

                  RNFS.readFile(path, 'base64')
                  .then(res =>{
                    console.log('got base64 len = ' + res.length)

                    continuePostCreation(res)

                  }).catch((x) => {
                    continuePostCreation() // continue w/ normal image if base64 fail
                  })

              }).catch((x) => {
                continuePostCreation() // continue w/ normal image if overlay fail
              })

          } else continuePostCreation() // normal post creation

      })

    } else {
      continuePostCreation()
    }

  }
  onPaypalSuccess = () => {
    this.props.status({ status: {}, then: this.onPaypalStatus, err: this.onPaypalError })
  }
  yesModal = ( ) => {
    this.props.navigation.navigate('paymentOptions', { })
    this.alert.hideModal( )
  }
  yesModalFundMe = ( ) => {
    this.props.navigation.navigate('paymentOptions', { })
    this.alertFundMe.hideModal( )
  }
  onPaypalError = err => Alert.alert(JSON.stringify(err))
  onChangePrice = text => this.setState({ priceState: text })
  onChangeCurrency = currencyCode => this.setState({ currencyState: currencyCode })

  clearSong = ( ) => this.setState({ song: null })
  clearLocation = ( ) => this.setState({ locationId: '', locationCoord: '', locationName: '' })

  onPaypalStatus = response => {
    let status = response.data.data

    this.setState({ Expired: status.Expired, Expires: status.Expires
                  , Nonce: status.Nonce, Prefix: 'paypal_access'
                  , name: status.name, email: status.email
                  , fetching: false, error: false
                  , loading: false
                  , verified: status.PayerStatus === 'verified'
                })
  }
  onTitleMyShop = text => this.setState({ countText : text.length.toString( ), myshopTitle : text })

  doneDelivery = ({ data }) => {

    var iSells = this.state.iSells
    iSells.push(data)
    this.hideTabbar()
    this.setState({ iSells: iSells, myshopTitle: '', priceState: 0, currencyState: '', countText: '', myshopDes: '' })

  }
  tapOnImage = () => {
    Keyboard.dismiss()
    if (this.offsetY.__getValue() == 1) {
      this.hideTabbar()
    }
    if (this.commentBox.__getValue() == 1) {

      this.inputCapnofocus()
    }
  }
  // pass in this function so we can unlock the editable fields if user Cancels
  onDelivery = (clearEditLock) => {
    console.log("edit post my shop in on Delivery = " + clearEditLock)
    console.tron.display({
      name: `onDelivery`,
      preview: ``,
      value: {
        state: this.props
      }
    })

    let data = {}
    data.Left = convertToPercent(coordinateDefault, width, heightImage).xPercent

    data.Top = convertToPercent(coordinateDefault, width, heightImage).yPercent

    data.Name = this.state.myshopTitle
    data.Color = this.state.myshopDes
    data.Price = this.state.priceState.replace(',','') // parsefloat doesn't work with commas
    data.Currency = this.state.currencyState
    if (this.state.type == CREATE) {
      const { navigation: { state: { params: { image: { uri, base64 } } } } } = this.props
      data.Image = uri
    } else {
      const { navigation: { state: { params: { data: { PostId, Version } } } } } = this.props
      data.Image = getUri(
        PostId, Version)
    }

    this.setState({
      priceTop: 0
    }, () => this.props.navigation.navigate("myShopDelivery",
      { 'clearEditLock' : clearEditLock, doneDelivery: this.doneDelivery, data }))

  }
  loadMoreEndorseData = () => {
    this.setState({ shoppableSearch : true })
    console.tron.log(`loadMoreEndorseData`)
    this.props.shoppableCatalogSearch(this.state.endorseText, this.endorseSearch.items.length, 100, this.searchOptions)
  }
  onMyShopDes = (text) => this.setState({ myshopDes: text })

  onCloseUserTag = (index) => {
    var userTags = this.state.userTags
    userTags[index] = false
    this.setState({ userTags })
  }
  onCloseTheySell = (index) => {
    var theySell = this.state.theySell
    theySell[index] = false
    this.setState({ theySell: theySell })
  }
  onCloseDonate = (index) => {
    let donate = this.state.donate.concat()
    donate[index] = false
    // donate = donate.filter(function(value, idx) { return index != idx; }); // causes problems with tagref
    this.setState({ donate })
  }
  onCloseIsell = (index) => {
    var iSells = this.state.iSells
    iSells[index] = false
    this.setState({ iSells })
  }
  myShop = ( ) => {
    const missingPaypal = this.state.userLoaded && this.state.isStandardUser ? !this.state.havePaypal : this.state.Expired
    const isNewPost = this.state.type != this.EDIT
    const postImageUri = isNewPost ? this.props.navigation.state.params.image.uri : null
    
    console.log("ready to render EditPostMyShopV2 isVideoRendering = " + this.state.isVideoRendering + " final rendered video from redux = " + this.props.finalRenderedVideo)

    // once we have a final video we are good to go for my shop camera use
    let rendering = this.state.isVideoRendering && !this.props.finalRenderedVideo
  
    return (<EditPostMyShopV2
      isNewPost={isNewPost}
      havePaypal={!missingPaypal}
      post={this.props.post}
      postImageUri={postImageUri}
      doneDelivery={this.doneDelivery}
      showDoneBar={this.state.showDoneBar}
      user={this.props.auth.user}
      auth={this.props.auth}
      exchangeRates={this.props.exchangeRates}
      onMyShopDes={this.onMyShopDes}
      onDelivery={this.onDelivery}
      navigation={this.props.navigation}
      titleInput={this.state.myshopTitle}
      myshopDes={this.state.myshopDes}
      onBlur={this.inputPriceNofocus}
      priceTop={this.state.priceTop}
      onFocus={this.inputPricefocus}
      onTitleMyShop={this.onTitleMyShop}
      countText={this.state.countText}
      priceState={this.state.priceState}
      onChangePrice={this.onChangePrice}
      currencyState={this.state.currencyState}
      onChangeCurrency={this.onChangeCurrency}
      setMyShopMode={this.setMyShopMode}
      enableKeyboardListeners={this.enableKeyboardListeners}
      isMainPostVideoRendering={rendering}
      />
    )
  }
  captionInput = ( shouldDisplay ) => {
    let waitExtra = this.state.type === this.EDIT && this.props.post === null
    // change to use default caption in state, which comes from user defaults in case user went back
    // before posting or app crashed during post edit
    let isWeb = Platform.OS == 'web' // anchor to bottom on web
    let webStyle = isWeb ? {position : 'absolute', bottom: 0} : {}
    return (waitExtra?(<Text></Text>):
      <SearchBarComponent
        ref={ ref => this.captionRef = ref }
        autoCorrect={true}
        spellCheck={true}
        initialValue={(this.props.post&&this.state.type===this.EDIT)? this.props.post.Caption: this.state.caption}
        atTaggable={true}
        textInputStyle={[styles.textInputStyle, {fontFamily : Fonts.style.font.regular}, {borderColor: 'white'}]} // note: font is not set here
        onChangeText={ (text) => {
          console.log(`on change text called, text is now ${text}`)
          if( text.length > 9999 )
            text = text.slice(0,9999)
            this.captionRef.value = text
            this.captionRef.setState({ render : true })

          this.setState({caption : text})

          AsyncStorage.setItem("EditPostScreenSavedCaption", text)  // this is cleared in post sagas success 

          /* not eyt for web
          userDefaults.set('editPostScreenCaption', text)
          .then(data => console.log("save user defaults success:  caption " + JSON.stringify(data)))   // Save success
          */

        }}
        blurOnSubmit={false}
        api={this.api}
        following={this.props.following}
        multiline={true}
        numberOfLines={5}
        onBlur={this.inputCapnofocus}
        onfocus={this.inputCapforcus}
        hiddenClear autoGrow={true}
        placeholder={I18n.t('editpost.writeACaption')}
        style={[{ height: 70, width: width, backgroundColor: 'black', display : (shouldDisplay? 'flex': 'none') },
                {backgroundColor: 'white', borderColor: 'white', borderTopColor: '#888888', borderTopWidth: 1, color: 'white'}, /* for white themed border */
                webStyle
              ]} />
    )
  }
  locationText = ( ) => {
    // <View style={styles.postDetail}>
    // <SvgLocationX size={styles.postDetailXSize} />
    
    return (
      <View style={styles.postDetail}>
        <View style={[styles.postDetailPin]}>
          <SvgLocationPin size={styles.postDetailPinSize} />
        </View>
        <TouchableHighlight style={styles.postDetailTextWrapper} onPress={() => this.deactivateTabs()}>
          <Text numberOfLines={1} style={styles.postDetailText}>{this.state.locationName}</Text>
        </TouchableHighlight>
        <TouchableHighlight style={[styles.postDetailX]} onPress={this.clearLocation.bind(this)}>
          <Image source={Images.deleteButtonBlack} style={{height: styles.postDetailXSize, width: styles.postDetailXSize, resizeMode : 'contain'}} />
        </TouchableHighlight>
      </View>
    )
  }

  songDetail = ( ) => {
    return (
      <View style={styles.postDetail}>
        <View style={[styles.postDetailPin]}>
          <Image source={Images.music} style={{height: styles.postDetailPinSize, width: styles.postMusicDetailPinSize, resizeMode : 'contain'}} />
        </View>
        <TouchableHighlight style={styles.postDetailTextWrapper} onPress={() => this.deactivateTabs()}>
          <Text numberOfLines={1} style={styles.postDetailText}>{"'" + this.state.song.song + "' by " + this.state.song.artist}</Text>
        </TouchableHighlight>
        <Image source={{uri: this.state.song.imageUrl}} style={styles.postDetailAlbumIcon} />
        <TouchableHighlight style={[styles.postDetailX]} onPress={this.clearSong.bind(this)}>
          <Image source={Images.deleteButtonBlack} style={{height: styles.postDetailXSize, width: styles.postDetailXSize, resizeMode : 'contain'}} />
        </TouchableHighlight>
      </View>
    )
  }

  bottomBar = ( ) => {if (isIPhoneX() && this.state.priceTop == 0) return (<View style={{width: 414, height: 22, backgroundColor: "#ffffff"}}></View>)
                      else return null}
  renderTab = ( ) => {
    if (this.state.screenTitle == this.SHARING)
      return null
    const touchEnd = index => event => { this.onPressIcon ( index ) }
    let viewStyle = { flex : 0.2, flexDirection : 'row', width : '20%'
                    , backgroundColor: 'white', overflow: 'hidden' }
      , styleBorder = { marginTop: -20
                      , borderTopLeftRadius: 25 , borderTopRightRadius: 25
                      , ... viewStyle }
    return (
      <View style={[styles.bottomBar, styles.shadow]}>
        {this.state.arrayActive.map((item, index) => {
          let touchEndIndex = touchEnd (index)
          const bigger = item == true // index == 2
          return (<View key={index}
            style={ bigger ? styleBorder : viewStyle }
            onStartShouldSetResponder={( ) => true}
            onMoveShouldSetResponder={( ) => true}
            onResponderTerminationRequest={( ) => true}
            onResponderTerminate={touchEndIndex}
            onTouchStart={touchEndIndex}>
            <IconWithTextComponent
              containerStyle={[styles.containerStyle, bigger && styles.styleMiddlebar]}
              isSVGEditPost
              svgSize={bigger ? 40 : 30}
              textStyle={item == true ? styles.textStyleActive : styles.textStyle}
              type={this.arrayIcon[index]}
              text={this.arrayText[index]}
              active={item}
              onPress={( ) => { }}
            />
            <View style={styles.divider}>
              <SvgDivider width={2} height={60} />
            </View>
          </View>
          )
        })
        }
      </View>
    )
  }

  renderMusic = (styleCaption, item, index, heightImage) => {
    if( !item ) return null
    return <Text>{`Let there be music #${index}`}</Text>
  }
  renderDonate = (styleCaption, item, index, widthImage, heightImage) => {
    if( !item ) return null
    const currency = 'USD'
    const price = 0 // i18nCurrency(item.Amount, currency, {extended: true})
    return (<DragComponent
      ref={ref => this.tagRefs['donate'][index] = ref}
      widthImage={widthImage}
      heightImage={heightImage}
      onCustomFrame={this.onCustomFrame}
      type={DONATATION}
      key={index}
      index={index}
      onPressClose={() => this.onCloseDonate(index)}
      style={styleCaption}

      data={item}
      text={item.CharityName}
      price={price}
      isDonate
      testOverlap={this.isOverlappingTag.bind(this)}
      findOpenSpace={this.findOpenSpace.bind(this)}
      isClose={this.state.showTagCloseButtons}
    />
    )
  }

  renderISells = (styleCaption, item, index, widthImage, heightImage) => {
    console.log(`renderISells type ${this.state.type}, item = ` + JSON.stringify(item))
    const isNewPost = this.state.type != this.EDIT
    const { post } = this.props
    let postImageUri = null
    if (isNewPost)
      postImageUri = this.props.navigation.state.params.image.uri
    else
      postImageUri = `${KargoeConfig.baseUrlMedia}/${post.PostId}-thumb.jpg?${post.Version}`
    if( !item ) return null
    let newItem = Object.assign({}, item)
    if (typeof item.Image == 'string' && item.Image.trim().length) {
      const images = item.Image.split('??')
      newItem.Image = images[0] == '__DEFAULT__' ? /*this.defaultImageUrl*/postImageUri : images[0]
    }
    else
      newItem.Image = postImageUri // this.defaultImageUrl
    const currency = typeof item.Currency != 'undefined' ? item.Currency : 'USD'
    const priceStr = i18nCurrency(item.Price, currency, {extended: true})
    const tokenPrice = typeof item.TokenPrice != 'undefined' ? item.TokenPrice : null
    return (<DragComponent
      ref={ref => this.tagRefs['isell'][index] = ref}
      widthImage={widthImage}
      heightImage={heightImage}
      onCustomFrame={this.onCustomFrame}
      type={MYSHOP}
      key={index}
      index={index}
      onPressClose={() => this.onCloseIsell(index)}
      style={styleCaption}
      isIsell
      data={newItem}
      text={item.Name}
      rawPrice={item.Price}
      price={priceStr}
      tokenPrice={tokenPrice}
      isProduct
      testOverlap={this.isOverlappingTag.bind(this)}
      findOpenSpace={this.findOpenSpace.bind(this)}
      isClose={this.state.showTagCloseButtons}
    />
    )
  }
  renderTheySells = (styleCaption, item, index, widthImage, heightImage) => {
    if( !item ) return null
    const currency = typeof item.Currency != 'undefined' ? item.Currency : 'USD'
    return (<DragComponent
      ref={ref => this.tagRefs['theysell'][index] = ref}
      widthImage={widthImage}
      heightImage={heightImage}
      onCustomFrame={this.onCustomFrame}
      type={ENDORSE}
      key={index}
      index={index}
      onPressClose={() => this.onCloseTheySell(index)}
      style={styleCaption}
      onPress={this.onPressProduct}
      data={item}
      text={item.Title}
      price={item.PriceMin ? i18nCurrencyDuo(item.PriceMin, item.PriceMax, currency, {extended: true}) : ""}

      isProduct
      testOverlap={this.isOverlappingTag.bind(this)}
      findOpenSpace={this.findOpenSpace.bind(this)}
      isClose={this.state.showTagCloseButtons}
    />
    )
  }
  renderUserTags = (styleCaption, item, index, widthImage, heightImage) => {
    if( !item ) return null
    return (<DragComponent
      ref={ref => this.tagRefs['user'][index] = ref}
      widthImage={widthImage}
      heightImage={heightImage}
      type={PEOPLE}
      onCustomFrame={this.onCustomFrame}
      key={index}
      index={index}
      onPressClose={() => this.onCloseUserTag(index)}
      style={styleCaption}
      onPress={this.onPressAvatarCaption}
      data={item}
      text={item.Username}
      isAvatar
      testOverlap={this.isOverlappingTag.bind(this)}
      findOpenSpace={this.findOpenSpace.bind(this)}
      isClose={this.state.showTagCloseButtons}
    />
    )
  }
  render() {
    console.tron.display({name: `EditPostScreen`,preview: `render`,value: {state: this.state, alreadyDisplayedSharingAlert: this.alreadyDisplayedSharingAlert}})

    let captionDiff = this.captionRef&&!this.captionRef.blurred? this.captionRef.nextHeight - 70: 0
    console.log("captionDiff = " + captionDiff + " typeof = " + typeof captionDiff)
    captionDiff = isNaN(captionDiff) ? 0 : captionDiff
    console.log("fixed:  captionDiff = " + captionDiff + " typeof = " + typeof captionDiff)
    const { navigation: { state: { params: data } } } = this.props
    const widthImage = width
    const heightImage = (widthImage / this.state.naturalAR)
    const offsetYIPXAdjust = isIPhoneX() ? -42 : 0
    const offsetY = this.offsetY.interpolate(
      {
        inputRange: [0, 1],
        outputRange: [startY - captionDiff + offsetYIPXAdjust, endY],
        extrapolate: 'clamp',

      });
    const marginIphoneX = isIPhoneX() ? (-20) : 0
    const commentBox = this.commentBox.interpolate(
      {
        inputRange: [0, 1],
        outputRange: [0, this.state.priceTop - 26], // 44 reduce gap between keyboard and textinput
        extrapolate: 'clamp',

      });

    const hScale = width / 100
    const vScale = heightImage /*(this.state.naturalAR * width)*/ / 100

    // TODO: move to componentWillReceiveProps nextprops
    if (this.props.shoppableItems.filter != 'ShoppableById' && this.props.shoppableItems.modified && this.props.shoppableItems.modified > this.endorseSearch.modified) {
        this.endorseSearch.modified = this.props.shoppableItems.modified
        if (this.props.shoppableItems.start == 0) {
          console.tron.log(`EditPostScreen render, shoppable items, cleared`)
          this.endorseSearch.items = this.props.shoppableItems.list.concat([])
        }
        else {
          console.tron.log(`EditPostScreen render, shoppable items, adding to length: ${this.endorseSearch.items.length}`)
          this.endorseSearch.items = this.endorseSearch.items.concat(this.props.shoppableItems.list)
        }
    }
    const endorseItems = this.endorseSearch.items
    const offer = Object.assign({}, this.state.offer)
    // this tag should be <Video, change back to <Image to try to get edit post (create post) working
    const videoTag = this.props.finalRenderedVideo && this.state.type === CREATE ?
      (<Image style={[styles.video, { height: heightImage }]}
        source={{ uri: this.props.finalRenderedVideo }}
        muted={true}
        repeat={true}
        onLoad={response => {
          console.log("edit post screen Image onLoad response = " + JSON.stringify(response))

          // web comment out for now const { width, height } = response.naturalSize;

          const width = 640
          const height = 640*4/3

          console.log("video size = " + width + " " + height)
          // only set state if different, or we might get render recursion
          if (Math.abs(this.state.naturalAR - width / height) > 0.01)
          console.log('resetting naturalAR to ' + width / height)
          this.setState({
            naturalAR: width / height,
          })
        }}
      />) : null
    const userTags = this.state.userTags.length > 0 &&
      this.state.userTags.map((item, index) => {
        const styleCaption = convertPercentToPoint(item, hScale, vScale)
        return this.renderUserTags(styleCaption, item, index, widthImage, heightImage)
      })
    const theySellTags = this.state.theySell.length > 0 &&
      this.state.theySell.map((item, index) => {
        const styleCaption = convertPercentToPoint(item, hScale, vScale)
        return this.renderTheySells(styleCaption, item, index, widthImage, heightImage)
      })
    const iSellTags = this.state.iSells.length > 0 &&
      this.state.iSells.map((item, index) => {
        const styleCaption = convertPercentToPoint(item, hScale, vScale)
        console.log("item before render = " + JSON.stringify(item))
        let result = this.renderISells(styleCaption, item, index, widthImage, heightImage)
        console.log("item after render = " + JSON.stringify(item))
        return result // this.renderISells(styleCaption, item, index, heightImage)
      })
    const donateTags = this.state.donate.length > 0 &&
      this.state.donate.map((item, index) => {
        const styleCaption = convertPercentToPoint(item, hScale, vScale)
        return this.renderDonate(styleCaption, item, index, widthImage, heightImage)
      })
    //console.log("this.state.uriToUse = " + this.state.uriToUse)
    console.log("before render this.state.screenTitle = " + this.state.screenTitle)  // Edit Post
    console.log("before render this.EDITPOST          = " + this.EDITPOST) // Edit ah ha mismatch
    console.log("before render this.TAGGING          = " + this.TAGGING) // Edit ah ha mismatch

    // for testing

    const livePostUI = (<View style ={{position: 'absolute', top: 10, left: 10, width: "50%",
        alignItems: 'center', flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-evenly'}}>
      <Switch 
              onTintColor="rgba(0,193,214,1)"
              onValueChange={this.onValueChangeLivePost} value={this.state.isLivePost} />
       <Text style={{overflow: 'hidden', borderRadius: 2, fontSize: 10, backgroundColor: 'rgba(255,255,255,0.5)'}}> new live stream post </Text>
    </View>
    )

    if (false) {
    let username = null
    if (state.auth && state.auth.user) username = state.auth.user.Username

    if (this.liveStreamTokens) {

        let foundUsername = Object.keys(this.liveStreamTokens).find(el => el === username)

        if (!foundUsername) {
          //livePostUI = null // shut off create live post if you are not in the list
          //console.log("shutting off ability to make live stream post")
        }

    }
    }
    const active = this.state.arrayActive
    const isCaptionMode = !(active[ENDORSE] || active[PEOPLE] || active[DONATATION] || active[LOCATION] || active[MYSHOP] || active[MUSIC])
    //                     {!this.state.arrayActive[MYSHOP] && this.captionInput(!this.state.arrayActive.some(e => e === true))}

    const isWeb = Platform.OS == 'web' // some items not converted to web yet so mask them

    return (
      <BaseScreen
        fullLoading={this.props.fetching || this.state.waitingForPost /*|| this.state.isVideoRendering*/}
        darkStatusbar
      >
        <Modal
          animationType="slide"
          transparent={true}
          visible={this.state.showQRAlert}
          onRequestClose={() => {
          }}>
          <View style={{marginTop: 0, flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <View style={{backgroundColor: 'white', width: "80%", height:"50%", borderRadius: 10}}>
              <Text style={{margin: 20, fontSize: 80, textAlign: 'center'}}>🤑</Text>
              <Text style={{marginLeft: 20, marginRight: 20}}>{`${I18n.t("editpost.shareToGet")} ${offer.Description} at ${offer.VendorName}`}</Text>

              <TouchableOpacity activeOpacity={0.5} style={{marginTop: 40, flex: 1, justifyContent: 'center', alignItems: 'center', height: 50}}
                onPress={() => {
                  this.setState({showQRAlert: !this.state.showQRAlert})
                }}>
                <Text style={{ textAlign : 'center' }}>{I18n.t("editpost.gotIt")}</Text>
              </TouchableOpacity>
            </View>
          </View>
        </Modal>

        <MainNavBarScreen
          ref={(view) => {
            if (view) this.navigationBar = view
          }}
          rightTitleStyle={styles.rightTitleStyle}
          title={this.state.screenTitle}
        />

        <View style={styles.container}>
          <View style={[styles.container, styles.avoiding, styles.noneColor]} >
            <View style={[styles.container, styles.noneColor]}>
              {!!this.state.locationName && this.state.locationName.length > 0 && this.locationText()}
              {!!this.state.song && this.songDetail()}
              <View style={[styles.top, styles.noneColor]} >
                  <TouchableOpacity activeOpacity={1} onPressIn={this.tapOnImage} ref={ref => {this.mainContainerView = ref}} >
                    <ImageBackground source={ this.state.uriToUse ? {uri: this.state.uriToUse} : {}} style={[styles.image, { height: heightImage }]} resizeMode='contain' >
                      {videoTag}
                      {userTags}
                      {theySellTags}
                      {iSellTags}
                      {donateTags}
                      {livePostUI}
                    </ImageBackground>
                  </TouchableOpacity>
              </View>
              {((this.state.screenTitle == this.TAGGING || this.state.screenTitle == this.EDITPOST))  &&
                <Animated.View style={[styles.bottom, {top: offsetY}, styles.shadow]}>
                  <Animated.View style={[styles.bar, {
                    marginTop: commentBox,
                    height: !this.state.arrayActive.some(e => e === true) ? (130+captionDiff) : 60
                  }]}>
                    {!isWeb && this.renderTab()}
                    {this.captionInput(!this.state.arrayActive.some(e => e === true))}
                  </Animated.View>
                  {this.bottomBar()}
                  <View style={[styles.container, styles.whitecolor]}>
                    {this.state.arrayActive[ENDORSE] == true && !!endorseItems && this.showEndorse(endorseItems)}
                    {this.state.arrayActive[PEOPLE] == true && this.showPeople(this.state.peoples)}
                    {this.state.arrayActive[DONATATION] == true && this.donatation(this.state.charities)}
                    {this.state.arrayActive[LOCATION] == true && this.showLocation()}
                    {this.state.arrayActive[MYSHOP] == true && this.myShop()}
                    {this.state.arrayActive[MUSIC] == true && this.showMusic(this.props.music)}
                  </View>
                </Animated.View>}
            </View>
            {false && (this.state.screenTitle == this.SHARING) && <View
              style={[styles.sharing, { bottom: isIPhoneX() ? 10 : 0 }]}>
              <SharingComponent // keep a ref so we can get which of the 4 sharing buttons are on
                onRef={(function(x) {this.sharingComponent = x}).bind(this)}
                onValueChange={this.onToggleSwitch} value={this.state.switchIsOn} // share tags
                onValueChangeLogo={this.onToggleSwitchLogo} valueLogo={this.state.switchIsOnLogo} // share logo
              />
            </View>
            }
          </View>
          <View/>
        </View>

        {this.props.fetching && <Text style={{position: 'absolute', bottom: '50%', left: 50}}>waiting for PayPal...</Text>}

        <AlertMessage
          ref={(alert) => this.alert = alert}
          title={I18n.t('editpost.waitASecondMyShop')}
          yesModal={this.yesModal}
        />

        <AlertMessage
          ref={(alert) => this.alertFundMe = alert}
          title={I18n.t('editpost.waitASecondFundMe')}
          yesModal={this.yesModalFundMe}
        />

        <Modal ref={"theysellpaypal"} visible={this.state.errorPayPal} transparent={true}>
          <View style={{ flex : 1, width : width * 0.8, marginLeft : width * 0.1, maxHeight : 150, marginTop : height * 0.5 - 60, backgroundColor : 'white', borderColor: 'black', borderWidth: 1, borderRadius : 25, flexDirection : 'column' }}>
            <View style={{ borderBottomWidth : 1, borderColor : '#4f5271', alignItems : 'center', justifyContent : 'center', paddingTop : 15, paddingBottom : 15, paddingLeft : 15, paddingRight: 15 }}>
              <Text style={{ fontSize : 16, fontFamily : Fonts.style.font.regular, textAlign : 'center' }}>
              {I18n.t("editpost.getPaid")}
              </Text>
            </View>
            <View style={{ flex : 1, flexDirection: 'row', alignItems : 'center', justifyContent : 'center' }}>
              <TouchableOpacity style={{ height : '100%', flex : 1/2, alignItems : 'center', justifyContent : 'center', borderRightWidth : 1, borderColor : '#4f5271' }}
                                onPress={( ) => {
                                  this.handleSave('ignored')
                                  // close the popup by changing the visibility state
                                  this.setState({ errorPayPal : false })
                                }}>
                <Text style={{ fontSize : 12, fontFamily : Fonts.style.font.regular, color : '#4f5271', padding : 15 }}>{I18n.t("editpost.noThanks")}</Text>
              </TouchableOpacity>
              <TouchableOpacity style={{ height : '100%', flex : 1/2, alignItems : 'center', justifyContent : 'center' }} onPress={( ) => {
                this.props.navigation.navigate('paymentOptions', { })
                this.setState({ errorPayPal : false })
              }}>
                <Text style={{ fontSize : 12, fontFamily : Fonts.style.font.regular, color : '#4f5271', padding : 15 }}>{I18n.t("editpost.addPayPal")}</Text>
              </TouchableOpacity>
            </View>
          </View>
        </Modal>

        <MoneyFaceMessage visible={this.state.alertMessage.length > 0} nearTop={true} onClose={this.clearAlertMessage}>
          <Text style={{fontSize : 16, fontFamily : Fonts.style.font.regular, textAlign : 'center'}}>
            {this.state.alertMessage}
          </Text>
        </MoneyFaceMessage>

        <ThumbsDownMessage visible={this.state.errorMessage.length > 0} nearTop={true} onClose={this.clearErrorMessage}>
          <Text style={{fontSize : 16, fontFamily : Fonts.style.font.regular, textAlign : 'center'}}>
            {this.state.errorMessage}
          </Text>
        </ThumbsDownMessage>

      </BaseScreen>
    )
  }
}

/*
*/

const mapStateToProps = (state) => {
  return {
    users: state.userPopular.response,
    UserId: state.auth.user.UserId,
    auth: state.auth,
    post: state.posts.readPost,
    posts: state.posts,
    postTagDetail: state.posts.postTagDetail,
    kargoeTag: state.kargoeTag,
    // folllowers: state.getFollow.followers.data,
    following: state.getFollow.following.data, // state.user.following
    charity: state.charity, // .charities
    repost: state.posts.repost,
    fetching: state.paypal.fetching,
    success: state.user.success,
    error: state.user.error,
    oneRenderedFrame: state.posts.oneRenderedFrame,    // next 4 are file urls (this image data is not posted, for temp display)
    finalRenderedVideo: state.posts.finalRenderedVideo,  // only for video post
    tileurl: state.posts.tileurl,   // only for video post
    thumburl: state.posts.thumburl,  // used for video post and stil image post
    shoppableItems: state.shoppable.items, // force update through componentWillReceiveProps
    options: state.postCreation.basePostWallOptions,
    nav: state.nav,
    user: state.user,
    coupon: state.coupon,
    recentBarcoderOutput: state.swiper.recentBarcoderOutput, // from using swiper bar coder not internal camera barcoder
    music: state.appleMusic,
    musicModified: state.appleMusic.modified, // cause update
    updatePostProgress: state.posts.updatePostProgress,
    exchangeRates: state.user.exchangeRates,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    progress: (amount) => dispatch(PostsActions.createStandardPostProgress(amount)),
    status: status => dispatch(PaypalActions.paypalStatusRequest(status)),
    readPost: (post) => dispatch(PostsActions.readPostRequest(post)),
    getPostTagDetail: (post) => dispatch(PostsActions.postTagDetailRequest(post)),
    getKargoeTag: data => dispatch(KargoeTagActions.kargoeTagRequest(data)),
    getSearchTag: data => dispatch(KargoeTagActions.kargoeTagSearchRequest(data)),
    searchItems: data => dispatch(KargoeTagActions.kargoeSearchItemsRequest(data)),
    searchUser: (data) => dispatch(UserPopularActions.userPopularRequest(data)),
    getFollowing: (userId) => dispatch(GetFollowActions.getFollowRequest(userId, false, {start: 0, limit: 300})),
    getCharities: () => dispatch(KargoeCareActions.kargoeCareRequest()),
    createPost: (post, files, emitter) => dispatch(PostsActions.createStandardPostRequest(post, files, emitter)),
    updatePost: (post) => dispatch(PostsActions.updatePostRequest(post)),
    repostAction: (post) => dispatch(PostsActions.repostRequest(post)),
    checkVideoRenderResults: (result) => dispatch(PostsActions.checkVideoRenderResults(result)),
    shoppableGetConfig: () => dispatch(ShoppableActions.shopGetConfig()),
    shoppableCatalogSearch: (search, start, limit, options) => dispatch(ShoppableActions.shopSearchItems(search, start, limit, 'THEYSELL_ONLY', options)),
    // shoppableCatalogSearch: (search, start, limit) => dispatch(ShoppableActions.shopSearchItems(search, start, limit, 'THEYSELL_ONLY', {shoppableOnly: true, brandName: 'Saks Fifth Avenue', sortBy: 'price'})),
    changeIndex: (index) => dispatch(SwiperActions.changeIndex(index)),
    listFollowing: (UserId, next) => dispatch(UserActions.listFollowingRequest({ UserId: UserId, next: next })),
    readUser: UserId => dispatch(UserActions.readRequest(UserId)),
    getOffer: offerId => dispatch(CouponActions.getOffer(offerId, null)),
    getVendor: userId => dispatch(CouponActions.getVendor(userId)),
    vendorOffers: UserId => dispatch(CouponActions.vendorOffers(UserId)),
    searchMusic: search => dispatch(AppleMusicActions.searchRequest(search)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditPostScreen)
